import gridKurortImg1 from "./img/grid-slider/resort-vacation/1.jpg";
import gridKurortImg2 from "./img/grid-slider/resort-vacation/2.jpg";
import gridKurortImg3 from "./img/grid-slider/resort-vacation/3.jpg";
import gridKurortImg4 from "./img/grid-slider/resort-vacation/4.jpg";
import gridKurortImg5 from "./img/grid-slider/resort-vacation/5.jpg";
import gridKurortImg6 from "./img/grid-slider/resort-vacation/6.jpg";
import gridKurortImg7 from "./img/grid-slider/resort-vacation/7.jpg";
import gridKurortImg8 from "./img/grid-slider/resort-vacation/8.jpg";
import gridKitchen1 from "./img/grid-slider/kitchen/kitchen1.jpg";
import gridKitchen2 from "./img/grid-slider/kitchen/kitchen2.jpg";
import gridKitchen3 from "./img/grid-slider/kitchen/kitchen3.jpg";
import gridKitchen4 from "./img/grid-slider/kitchen/kitchen4.jpg";
import gridKitchen5 from "./img/grid-slider/kitchen/kitchen5.jpg";
import gridKitchen6 from "./img/grid-slider/kitchen/kitchen6.jpg";
import gridKitchen7 from "./img/grid-slider/kitchen/kitchen7.jpg";
import gridAqua1 from "./img/grid-slider/aqua/aqua1.jpg";
import gridAqua2 from "./img/grid-slider/aqua/aqua2.jpg";
import gridAqua3 from "./img/grid-slider/aqua/aqua3.jpg";
import gridAqua4 from "./img/grid-slider/aqua/aqua4.jpg";
import promoImg1 from "./img/promos/promo1.jpg";
import promoImg2 from "./img/promos/promo2.jpg";
import promoImg3 from "./img/promos/promo3.jpg";
import promoImg4 from "./img/promos/promo4.jpg";
import promoImg5 from "./img/promos/promo5.jpg";
import promoImg6 from "./img/promos/promo6.jpg";
import promoImg7 from "./img/promos/promo7.jpg";
import promoImg8 from "./img/promos/promo8.jpg";
import promoImg9 from "./img/promos/promo9.jpg";
import promoImg10 from "./img/promos/promo10.jpg";
import promoImg11 from "./img/promos/promo11.jpg";
import img4 from "./img/promos/promo1.jpg";
import img5 from "./img/gallery-slider/home-page/fotogalereya5.jpg";
import img6 from "./img/gallery-slider/home-page/fotogalereya6.jpg";
import img7 from "./img/gallery-slider/home-page/fotogalereya7.jpg";
import img8 from "./img/gallery-slider/home-page/fotogalereya8.jpg";
import img9 from "./img/gallery-slider/home-page/fotogalereya9.jpg";
import img10 from "./img/gallery-slider/home-page/fotogalereya10.jpg";
import img11 from "./img/gallery-slider/home-page/fotogalereya11.jpg";
import img12 from "./img/gallery-slider/home-page/fotogalereya12.jpg";
import img13 from "./img/gallery-slider/home-page/fotogalereya13.jpg";
import img14 from "./img/gallery-slider/home-page/fotogalereya14.jpg";
import img15 from "./img/gallery-slider/home-page/fotogalereya15.jpg";
import img16 from "./img/gallery-slider/home-page/fotogalereya16.jpg";
import classic1img from "./img/rooms-slider/rooms-and-prices-page/classic1.jpg";
import classic2img from "./img/rooms-slider/rooms-and-prices-page/classic2.jpg";
import classic3img from "./img/rooms-slider/rooms-and-prices-page/classic3.jpg";
import modern1img from "./img/rooms-slider/rooms-and-prices-page/modern1.jpg";
import modern2img from "./img/rooms-slider/rooms-and-prices-page/modern2.jpg";
import modern3img from "./img/rooms-slider/rooms-and-prices-page/modern3.jpg";
import gridSpaImg1 from "./img/grid-slider/spa/1.jpg";
import gridSpaImg2 from "./img/grid-slider/spa/2.jpeg";
import gridSpaImg3 from "./img/grid-slider/spa/3.jpg";
import gridSpaImg4 from "./img/grid-slider/spa/4.jpg";
import gridSpaImg5 from "./img/grid-slider/spa/5.jpg";
import gridSpaImg6 from "./img/grid-slider/spa/6.jpg";
import gridSpaImg7 from "./img/grid-slider/spa/7.jpg";
import iconFloor from "./img/room-page/floor.png";
import iconCapacity from "./img/room-page/guys.png";
import iconView from "./img/room-page/mountains.png";
import iconSea from "./img/room-page/sea.png";
import iconShower from "./img/room-page/shower.png";
import iconSpace from "./img/room-page/ploshchad.png";
import iconConnected from "./img/room-page/connected.png";
import familyVacationBannerImg from "./img/banners/vacations/family-vacation.png";
import familyVacationBannerMobileImg from "./img/banners/vacations/family-vacation-mob.jpg";
import romanticVacationBannerImg from "./img/banners/vacations/romantic-vacation.png";
import romanticVacationBannerMobileImg from "./img/banners/vacations/romantic-vacation-mob.jpg";
import vacationForYourselfBannerImg from "./img/banners/vacations/vacation-for-yourself.png";
import vacationForYourselfBannerMobileImg from "./img/banners/vacations/vacation-for-yourself-mob.jpg";
import vacationWithFriendsBannerImg from "./img/banners/vacations/vacation-with-friends.png";
import vacationWithFriendsBannerMobileImg from "./img/banners/vacations/vacation-with-friends-mob.jpg";
import weddingSliderImg1 from "./img/events/wedding/aquazone.jpg";
import weddingSliderImg2 from "./img/events/wedding/park.jpg";
import weddingSliderImg3 from "./img/events/wedding/beach.jpg";
import weddingSliderIcon1 from "./img/events/wedding/icon1.png";
import weddingSliderIcon2 from "./img/events/wedding/icon2.png";
import weddingSliderIcon3 from "./img/events/wedding/icon3.png";
import weddingSliderIcon4 from "./img/events/wedding/icon4.png";
import weddingSliderIcon5 from "./img/events/wedding/icon5.png";
import extraService1 from "./img/extra-services/1.jpg";
import extraService2 from "./img/extra-services/2.jpg";
import extraService3 from "./img/extra-services/3.jpg";
import extraService4 from "./img/extra-services/4.jpg";
import extraService5 from "./img/extra-services/5.jpg";
import extraService6 from "./img/extra-services/6.jpg";
import extraService7 from "./img/extra-services/7.jpg";
import extraService8 from "./img/extra-services/8.jpg";
import placesIcon1 from "./img/events/wedding/placesIcon1.png";
import placesIcon2 from "./img/events/wedding/placesIcon2.png";
import placesIcon3 from "./img/events/wedding/placesIcon3.png";
import placesIcon4 from "./img/events/wedding/placesIcon4.png";
import weddingGallery1 from "./img/events/wedding/gallery/1.jpg";
import weddingGallery2 from "./img/events/wedding/gallery/2.jpg";
import weddingGallery3 from "./img/events/wedding/gallery/3.jpg";
import weddingGallery4 from "./img/events/wedding/gallery/4.jpg";
import weddingGallery5 from "./img/events/wedding/gallery/5.jpg";
import weddingGallery6 from "./img/events/wedding/gallery/6.jpg";
import weddingGallery7 from "./img/events/wedding/gallery/7.jpg";
import weddingGallery8 from "./img/events/wedding/gallery/8.jpg";
import weddingGallery9 from "./img/events/wedding/gallery/9.jpg";
import weddingGallery10 from "./img/events/wedding/gallery/10.jpg";
import weddingGallery11 from "./img/events/wedding/gallery/11.jpg";
import weddingGallery12 from "./img/events/wedding/gallery/12.jpg";
import weddingGallery13 from "./img/events/wedding/gallery/13.jpg";
import weddingGallery14 from "./img/events/wedding/gallery/14.jpg";
import weddingGallery15 from "./img/events/wedding/gallery/15.jpg";
import weddingGallery16 from "./img/events/wedding/gallery/16.jpg";
import forumImg from "./img/mice/conference/3.jpg";
import forumImg1 from "./img/mice/conference/4.jpg";
import forumImg2 from "./img/mice/conference/5.jpg";
import forumImg3 from "./img/mice/conference/6.jpg";
import forumImg4 from "./img/mice/conference/7.jpg";
import widthForumImg5 from "./img/mice/conference/8.jpg";
import widthForumImg6 from "./img/mice/conference/9.jpg";
import widthForumImg7 from "./img/mice/conference/10.jpg";
import conferenceIcon1 from './img/mice/conference/icons/10.png';
import conferenceIcon2 from './img/mice/conference/icons/11.png';
import conferenceIcon3 from './img/mice/conference/icons/12.png';
import conferenceIcon4 from './img/mice/conference/icons/13.png';
import conferenceIcon5 from './img/mice/conference/icons/5.png';
import conferenceIcon6 from './img/mice/conference/icons/6.png';
import conferenceIcon7 from './img/mice/conference/icons/7.png';
import conferenceIcon8 from './img/mice/conference/icons/8.png';
import conferenceIcon9 from './img/mice/conference/icons/9.png';
import iconHalls from "./img/mice/conference/icons/1.png"
import iconEquipment from "./img/mice/conference/icons/2.png"
import iconExcursions from "./img/mice/conference/icons/3.png"
import iconResidence from "./img/mice/conference/icons/4.png"
import birthdayIcon1 from "./img/events/birthday/icon1.png"
import birthdayIcon2 from "./img/events/birthday/icon2.png"
import birthdayIcon3 from "./img/events/birthday/icon3.png"
import birthdayIcon4 from "./img/events/birthday/icon4.png"
import birthdayIcon5 from "./img/events/birthday/icon5.png"
import birthdayIcon6 from "./img/events/birthday/icon6.png"
import iconCapacityBanner from "./img/events/wedding/icon-capacity.png"
import forumIcon1 from './img/mice/forum/icons/1.png';
import forumIcon2 from './img/mice/forum/icons/2.png';
import forumIcon3 from './img/mice/forum/icons/3.png';
import forumIcon4 from './img/mice/forum/icons/4.png';
import forumIcon5 from './img/mice/forum/icons/5.png';
import birthdayCentered1 from './img/events/birthday/centered/1.jpg';
import birthdayCentered2 from './img/events/birthday/centered/2.jpg';
import birthdayCentered3 from './img/events/birthday/centered/3.jpg';
import birthdayCentered4 from './img/events/birthday/centered/4.jpg';
import birthdayCentered5 from './img/events/birthday/centered/5.jpg';
import birthdayTavrika from './img/events/birthday/tavrika.jpg';
import birthdayBallroom from './img/events/birthday/ballroom.jpg';
import birthdayCircleTerrase from './img/events/birthday/circleterrase.jpg';
import birthdayGreenTerrase from './img/events/birthday/terrase.jpg';
import birthdayPaluba from './img/events/birthday/paluba.jpg';
import birthdayLaVeranda from './img/events/birthday/la-veranda.jpg';
import iconPhotozone from "./img/events/wedding/icon-photozone.png";
import iconThematic from "./img/events/wedding/icon-thematic.png";
import iconSpa from "./img/events/hen-party/icon1.png";
import iconBeach from "./img/events/hen-party/icon2.png";
import iconGirlDrink from "./img/events/hen-party/drinks.png";
import iconClearHand from "./img/events/hen-party/clearhand.png";
import iconList from "./img/events/hen-party/list.png";
import iconMassage from "./img/events/bachelor-party/handsIcon.png";
import iconDrinks from "./img/events/bachelor-party/drinkIcon.png";
import iconSauna from "./img/events/bachelor-party/saunaIcon.png";
import iconPrograms from "./img/mice/team-building/icons/1.png";
import iconSPA from "./img/mice/team-building/icons/2.png";
import iconExhibition from "./img/mice/exhibition/icons/1.png";
import iconEscort from "./img/mice/exhibition/icons/2.png";
import iconBonuses from "./img/mice/exhibition/icons/3.png";
import weddingImgGrid from "./img/events/grid-slider/1.jpg";
import ceremonyImgGrid from "./img/events/grid-slider/2.jpg";
import birthdayImgGrid from "./img/events/grid-slider/3.jpg";
import henPartyImgGrid from "./img/events/grid-slider/4.jpg";
import bachelorPartyImgGrid from "./img/events/grid-slider/5.jpg";
import conferenceImgGrid from "./img/mice/grid-slider/1.jpg";
import forumImgGrid from "./img/mice/grid-slider/2.jpg";
import exhibitionImgGrid from "./img/mice/grid-slider/3.jpg";
import intensiveImgGrid from "./img/mice/grid-slider/4.jpg";
import trainingsImgGrid from "./img/mice/grid-slider/5.jpg";
import teamImgGrid from "./img/mice/grid-slider/6.jpg";
import tourismImgGrid from "./img/mice/grid-slider/7.jpg";
import childrenAnimImg from "./img/family-holiday/1.jpg";
import childrenPoolImg from "./img/family-holiday/2.jpg";
import birthdayImg from "./img/family-holiday/3.jpg";
import playgroundImg from "./img/family-holiday/4.jpg";
import closePool1 from "./img/infrastructure/beach-pools/5.jpg";
import closePool2 from "./img/infrastructure/beach-pools/6.jpg";
import closePool3 from "./img/infrastructure/beach-pools/7.jpg";
import closePool4 from "./img/infrastructure/beach-pools/8.jpg";
import bannerPools from "./img/infrastructure/beach-pools/1.jpg";
// roomsImports
import otherRoomsModernStandart from "./img/rooms/modern/other-rooms/стандарт-мини.jpg"
import otherRoomsModernImproved from "./img/rooms/modern/other-rooms/улучшенный_мини.jpg"
import otherRoomsModernSemiLux from "./img/rooms/modern/other-rooms/полулюкс 2.jpg"
import otherRoomsModernLux from "./img/rooms/modern/other-rooms/люкс 1.jpg"
import otherRoomsModernSpa from "./img/rooms/modern/other-rooms/спа_мини.jpg"
import otherRoomsModernDisabled from "./img/rooms/modern/other-rooms/огр мини.jpg"
import otherRoomsModernPresident from "./img/rooms/modern/other-rooms/president.jpg"

import modernStandartHero from "./img/rooms-and-prices-page/banner-bg.jpg";
import modernStandart1 from "./img/rooms/modern/standart/main_slider_1.jpg";
import modernStandart2 from "./img/rooms/modern/standart/main_slider_2.jpg";
import modernStandart3 from "./img/rooms/modern/standart/main_slider_3.jpg";

import modernImprovedHero from "./img/rooms/modern/improved/hero.jpg";
import modernImproved1 from "./img/rooms/modern/improved/main_slider_1.jpg";
import modernImproved2 from "./img/rooms/modern/improved/main_slider_2.jpg";
import modernImproved3 from "./img/rooms/modern/improved/main_slider_3.jpg";

import modernSemiluxHero from "./img/rooms/modern/semi-lux/hero.jpg";
import modernSemilux1 from "./img/rooms/modern/semi-lux/main_slider_1.jpg";
import modernSemilux2 from "./img/rooms/modern/semi-lux/main_slider_2.jpg";
import modernSemilux3 from "./img/rooms/modern/semi-lux/main_slider_3.jpg";

import modernLuxHero from "./img/rooms/modern/lux/hero.jpg";
import modernLux1 from "./img/rooms/modern/lux/main_slider_1.jpg";
import modernLux2 from "./img/rooms/modern/lux/main_slider_2.jpg";
import modernLux3 from "./img/rooms/modern/lux/main_slider_3.jpg";

import modernSpaSuiteHero from "./img/rooms/modern/spa-suite/hero.jpg";
import modernSpaSuite1 from "./img/rooms/modern/spa-suite/main_slider_1.jpg";
import modernSpaSuite2 from "./img/rooms/modern/spa-suite/main_slider_2.jpg";
import modernSpaSuite3 from "./img/rooms/modern/spa-suite/main_slider_3.jpg";

import modernDisabledHero from "./img/rooms/modern/disabled/hero.jpg";
import modernDisabled1 from "./img/rooms/modern/disabled/main_slider_1.jpg";
import modernDisabled2 from "./img/rooms/modern/disabled/main_slider_2.jpg";
import modernDisabled3 from "./img/rooms/modern/disabled/main_slider_3.jpg";

import modernPresidentHero from "./img/rooms/modern/president/hero.jpg";
import modernPresident1 from "./img/rooms/modern/president/main_slider_1.jpg";
import modernPresident2 from "./img/rooms/modern/president/main_slider_2.jpg";
import modernPresident3 from "./img/rooms/modern/president/main_slider_3.jpg";

import otherRoomsClassicStandart from "./img/rooms/classic/other-rooms/standart.jpg";
import otherRoomsClassicImproved from "./img/rooms/classic/other-rooms/uluch.jpg";
import otherRoomsClassicSemilux from "./img/rooms/classic/other-rooms/half-lux.jpg";
import otherRoomsClassicLux from "./img/rooms/classic/other-rooms/lux.jpg";
import otherRoomsClassicPresident from "./img/rooms/classic/other-rooms/prezident.jpg";

import classicStandartHero from "./img/rooms/classic/standart/hero.jpg";
import classicStandart1 from "./img/rooms/classic/standart/main_slider_1.jpg";
import classicStandart2 from "./img/rooms/classic/standart/main_slider_2.jpg";
import classicStandart3 from "./img/rooms/classic/standart/main_slider_3.jpg";

import classicImprovedHero from "./img/rooms/classic/improved/hero.jpg";
import classicImproved1 from "./img/rooms/classic/improved/main_slider_1.jpg";
import classicImproved2 from "./img/rooms/classic/improved/main_slider_2.jpg";
import classicImproved3 from "./img/rooms/classic/improved/main_slider_3.jpg";

import classicSemiLuxHero from "./img/rooms/classic/semi-lux/hero.jpg";
import classicSemiLux1 from "./img/rooms/classic/semi-lux/main_slider_1.jpg";
import classicSemiLux2 from "./img/rooms/classic/semi-lux/main_slider_2.jpg";
import classicSemiLux3 from "./img/rooms/classic/semi-lux/main_slider_3.jpg";

import classicLuxHero from "./img/rooms/classic/lux/hero.jpg";
import classicLux1 from "./img/rooms/classic/lux/main_slider_1.jpg";
import classicLux2 from "./img/rooms/classic/lux/main_slider_2.jpg";
import classicLux3 from "./img/rooms/classic/lux/main_slider_3.jpg";

import classicPresidentLuxHero from "./img/rooms/classic/president/hero.jpg";
import classicPresidentLux1 from "./img/rooms/classic/president/main_slider_1.jpg";
import classicPresidentLux2 from "./img/rooms/classic/president/main_slider_2.jpg";
import classicPresidentLux3 from "./img/rooms/classic/president/main_slider_3.jpg";
// END roomsImports
// infra Imports
// infra Imports
import spaPageHero from "./img/infrastructure/spaPage/1.jpg";
import spaPageAquaImg from "./img/infrastructure/spaPage/2.jpg";
import spaPageGymImg from "./img/infrastructure/spaPage/3.jpg";
import spaPageSpaServicesImg from "./img/infrastructure/spaPage/4.jpg";
import aquaThermalPageHero from "./img/infrastructure/aquaThermal/1.jpg";
import aquaThermalPageFinka from "./img/infrastructure/aquaThermal/3.jpg";
import aquaThermalHammam from "./img/infrastructure/aquaThermal/4.jpg";
import aquaThermalRasul from "./img/infrastructure/aquaThermal/5.jpg";
import aquaThermalPeshchera from "./img/infrastructure/aquaThermal/6.jpg";
import gymHeroImg from "./img/infrastructure/gym/slider-fit.jpg";
import gymImg1 from "./img/infrastructure/gym/2.jpg";
import gymImg2 from "./img/infrastructure/gym/3.jpg";
import gymImg3 from "./img/infrastructure/gym/4.jpg";
import gymIcon1 from "./img/infrastructure/gym/ic1.png";
import gymIcon2 from "./img/infrastructure/gym/ic2.png";
import gymIcon3 from "./img/infrastructure/gym/ic3.png";
import gymIcon4 from "./img/infrastructure/gym/ic4.png";
import gymVeloGoriz from "./img/infrastructure/gym/кардио - велотренажер горизонтальныи.jpg";
import gymVelo from "./img/infrastructure/gym/кардио - велотренажер.JPG";
import gymBegovaya from "./img/infrastructure/gym/кардио - дорожка беговая.jpg";
import gymKross from "./img/infrastructure/gym/кардио - Кросс-тренажер.jpg";
import gymVert from "./img/infrastructure/gym/силовые - вертикальная тяга.jpg";
import gymMnogofunk from "./img/infrastructure/gym/силовые - Многофункциональныи силовои тренажер.jpg";
import gymPress from "./img/infrastructure/gym/свободные веса - скамья для пресса.jpg";
import gymSmit from "./img/infrastructure/gym/силовые свободные веса - машина смита.jpg";
import gymNogi from "./img/infrastructure/gym/силовые -Тренажер «разгибание ног».jpg";
import gymSpina from "./img/infrastructure/gym/свободные веса - Лавка для нижнеи части спины.jpg";
// END infra Imports
// single promotions Imports
import barhatniiSeasonBannerImg from "./img/promos/promo-barhat-seaon.jpg";
import ranneeBronirovaniePreviewImg from "./img/promos/rannee-peview.jpg";
import dlyaKrymchanBannerImg from "./img/promos/promo-otdyh-dlya-krymchan.jpg";
import krymskayaZimaBannerImg from "./img/promos/крымская-зима.jpg";
import letniyOtdyhBannerImg from "./img/promos/promo-letnoo-otdyh.jpg";
import dlitelnoeBannerImg from "./img/promos/promo-dlitelnoe.jpg";
import ranneeBronirovanieBannerImg from "./img/promos/rannee.jpg";
import onlineConferencesBannerImg from "./img/promos/online-conferences.jpg";

import krymskayaZimaContactBlockImg from "./img/promos/Fotograf-Krym-YAlta.jpg";
import krymskayaZimaPreviewImg from "./img/promos/krimskayaZimaPreview.jpg";
import dlyaKrymchanFormBannerImg from "./img/promos/крымчане.jpg";
import ranneeBronirovanieFormBannerImg from "./img/promos/межсезонье.jpg";
import letniyOtdyhFormBannerImg from "./img/promos/letniy-otdyh.jpg";
import dlitelnoeFormBannerImg from "./img/promos/длительное-проживание.jpg";
import onlineConferencesFormBannerImg from "./img/promos/онлайн-конференция.jpg";

// END single promotions Imports
// Restaurants Imports
import bannerRestaurants from "./img/infrastructure/restaurant/LaVeranda/1.jpg";
import buffet1 from "./img/infrastructure/restaurant/Buffet/1.jpg";
import buffet2 from "./img/infrastructure/restaurant/Buffet/2.jpg";
import buffet3 from "./img/infrastructure/restaurant/Buffet/3.jpg";
import buffet4 from "./img/infrastructure/restaurant/Buffet/4.jpg";
import buffet5 from "./img/infrastructure/restaurant/Buffet/5.jpg";
import grillGarden1 from "./img/infrastructure/restaurant/GrillGarden/1.jpg";
import grillGarden2 from "./img/infrastructure/restaurant/GrillGarden/2.jpg";
import grillGarden3 from "./img/infrastructure/restaurant/GrillGarden/3.jpg";
import grillGarden4 from "./img/infrastructure/restaurant/GrillGarden/4.jpg";
import grillGarden5 from "./img/infrastructure/restaurant/GrillGarden/5.jpg";
import laVeranda1 from "./img/infrastructure/restaurant/LaVeranda/1.jpg";
import laVeranda2 from "./img/infrastructure/restaurant/LaVeranda/2.jpg";
import laVeranda3 from "./img/infrastructure/restaurant/LaVeranda/3.jpg";
import laVeranda4 from "./img/infrastructure/restaurant/LaVeranda/4.jpg";
import lobbyMangup1 from "./img/infrastructure/restaurant/LobbyBarMangup/1.jpg";
import lobbyMangup2 from "./img/infrastructure/restaurant/LobbyBarMangup/2.jpg";
import lobbyMangup3 from "./img/infrastructure/restaurant/LobbyBarMangup/3.jpg";
import lobbyMangup4 from "./img/infrastructure/restaurant/LobbyBarMangup/4.jpg";
import lobbyMangup5 from "./img/infrastructure/restaurant/LobbyBarMangup/5.jpg";
import lobbyLounge1 from "./img/infrastructure/restaurant/LobbyLounge/1.jpg";
import lobbyLounge2 from "./img/infrastructure/restaurant/LobbyLounge/2.jpg";
import lobbyLounge3 from "./img/infrastructure/restaurant/LobbyLounge/3.jpg";
import poolBar1 from "./img/infrastructure/restaurant/PoolBar/1.jpg";
import poolBar2 from "./img/infrastructure/restaurant/PoolBar/2.jpg";
import poolBar3 from "./img/infrastructure/restaurant/PoolBar/3.jpg";
import poolBar4 from "./img/infrastructure/restaurant/PoolBar/4.jpg";
import tavrika1 from "./img/infrastructure/restaurant/Tavrika/1.jpg";
import tavrika2 from "./img/infrastructure/restaurant/Tavrika/2.jpg";
import tavrika3 from "./img/infrastructure/restaurant/Tavrika/3.jpg";
// END Restaurants import
// medical spa imports
import medicalSpaBannerIcon1 from "./img/medical-spa/bannerIcons/1.png";
import medicalSpaBannerIcon2 from "./img/medical-spa/bannerIcons/2.png";
import medicalSpaBannerIcon3 from "./img/medical-spa/bannerIcons/3.png";
import medicalSpaBannerIcon4 from "./img/medical-spa/bannerIcons/4.png";
import medicalSpaBannerIcon5 from "./img/medical-spa/bannerIcons/5.png";
import medicalSpaBannerImg from "./img/medical-spa/1.jpg";
import medicalSpaAdvIcon1 from "./img/medical-spa/advantagesIcons/1.png";
import medicalSpaAdvIcon2 from "./img/medical-spa/advantagesIcons/2.png";
import medicalSpaAdvIcon3 from "./img/medical-spa/advantagesIcons/3.png";
import medicalSpaAdvIcon4 from "./img/medical-spa/advantagesIcons/4.png";
import medicalSpaAdvIcon5 from "./img/medical-spa/advantagesIcons/5.png";
import medicalSpaAdvIcon6 from "./img/medical-spa/advantagesIcons/6.png";
import medicalSpaAdvIcon7 from "./img/medical-spa/advantagesIcons/7.png";
import medicalSpaAdvIcon8 from "./img/medical-spa/advantagesIcons/8.png";
import medicalSpaPopupImgVosstan from "./img/medical-spa/blocks/восстановление.jpg";
import medicalSpaPopupImgDetox from "./img/medical-spa/blocks/детокс.jpg";
import medicalSpaPopupImgSpina from "./img/medical-spa/blocks/здоровая-спина.jpg";
import medicalSpaPopupImgDvizhenie from "./img/medical-spa/blocks/свобода-движения.jpg";
import medicalSpaPopupImgSerdce from "./img/medical-spa/blocks/сильное-сердце.jpg";
import medicalSpaPopupImgStress from "./img/medical-spa/blocks/управление стрессом.jpg";
import medicalSpaPopupImgDihanieZdorovya from "./img/medical-spa/popup/дыхание-здоровья.jpg";

// END medical spa imports
// mice rooms imports
import parkRoomsSlider from "./img/mice/rooms/park.jpg";
import ballroomRoomsSlider from "./img/mice/rooms/ballrom.jpg";
import lobbyLoungeRoomsSlider from "./img/mice/rooms/Lobby-Lounge.jpg";
import preFunctionRoomsSlider from "./img/mice/rooms/Pre-Function.jpg";
import confrerenceRoomsImg1RoomsSlider from "./img/mice/rooms/konf-room1.jpg";
import confrerenceRoomsImg2RoomsSlider from "./img/mice/rooms/konf-room2.jpg";
import confrerenceRoomsImg3RoomsSlider from "./img/mice/rooms/konf-room-3.jpg";
import confrerenceRoomsImg4RoomsSlider from "./img/mice/rooms/konf-room4.jpg";
import tavrikaRoomsSlider from "./img/mice/rooms/Tavrika.jpg";
import SPAroomRoomsSlider from "./img/mice/rooms/The-Shore-SPA.jpg";
import beachRoomRoomsSlider from "./img/mice/rooms/beach.jpg";
import aroundTerRoomsSlider from "./img/mice/rooms/around-ter.jpg";
import aquaZoneRoomsSlider from "./img/mice/rooms/aqua-area.jpg";
// END rooms imports
// prices SPA imports
import SpaPricesBanner from "./img/infrastructure/spaPage/prices/1.jpg";
import adultSPA1 from "./img/infrastructure/spaPage/prices/adult1.jpg";
import adultSPA2 from "./img/infrastructure/spaPage/prices/adult2.jpg";
import adultSPA3 from "./img/infrastructure/spaPage/prices/adult3.jpg"
import childrenSPA1 from "./img/infrastructure/spaPage/prices/children1.jpg";
import childrenSPA2 from "./img/infrastructure/spaPage/prices/children2.jpg";
import childrenSPA3 from "./img/infrastructure/spaPage/prices/children3.jpg";
import subscriptionSPA1 from "./img/infrastructure/spaPage/prices/subscription1.jpg";
import subscriptionSPA2 from "./img/infrastructure/spaPage/prices/subscription2.jpg";
import subscriptionSPA3 from "./img/infrastructure/spaPage/prices/subscription3.jpg";
// END prices SPA imports
// transfer imports
import transfer1 from "./img/transfer/1.jpg";
import transfer2 from "./img/transfer/2.jpg";
// END transfer imports
// PartnersLogos
import partnerLogo1 from "./img/partners/1.jpg"
import partnerLogo2 from "./img/partners/2.jpg"
import partnerLogo3 from "./img/partners/3.jpg"
import partnerLogo4 from "./img/partners/4.jpg"
import partnerLogo5 from "./img/partners/5.jpg"
import partnerLogo6 from "./img/partners/6.jpg"
import partnerLogo7 from "./img/partners/7.jpg"
import partnerLogo8 from "./img/partners/8.jpg"
import partnerLogo9 from "./img/partners/9.jpg"
import partnerLogo10 from "./img/partners/10.jpg"
// END PartnersLogos
// VacanciesImg
import painterImg from "./img/vacancies/painter.jpg";
import pizzaMakerImg from "./img/vacancies/pizza-maker.jpg";
// END VacanciesImg
// afisha imports
import afishaImg1 from "./img/afisha/1.jpg";
import afishaImg2 from "./img/afisha/2.jpg";
import afishaImg3 from "./img/afisha/3.jpg";
import afishaImg4 from "./img/afisha/4.jpg";
import afishaImg5 from "./img/afisha/5.jpg";
import afishaImg6 from "./img/afisha/6.jpg";
import afishaImg14feb from "./img/afisha/14feb.jpg";
import afishaImg23feb from "./img/afisha/23feb.jpg";
import afishaImg8mar from "./img/afisha/8mar.jpg";
import afishaBelov from "./img/afisha/belov.jpg";
import afishaFilimonova from "./img/afisha/filimonova.jpg";
import afishaSafronova from "./img/afisha/safronova.jpg";
// END afisha imports
// LOVE DAY imports
import loveDaySlide1 from "./img/loveDay/1.1.jpg"
import loveDaySlide2 from "./img/loveDay/1.2.jpg"
import loveDaySlide3 from "./img/loveDay/1.3.jpg"
import loveDaySlide4 from "./img/loveDay/6.jpg"
import loveDaySlide5 from "./img/loveDay/7.jpg"
import loveDaySlide6 from "./img/loveDay/8.jpg"
import loveDaySlide7 from "./img/loveDay/9.jpg"
import loveDaySlide8 from "./img/loveDay/10.jpg"
// end LOVE DAY imports
// DEFENDER DAY imports
import defenderDaySlide1 from "./img/defenderDay/1.jpg";
import defenderDaySlide2 from "./img/defenderDay/2.jpg";
import defenderDaySlide3 from "./img/defenderDay/3.jpg";
import defenderDaySlide4 from "./img/defenderDay/4.jpg";
import defenderDaySlide5 from "./img/defenderDay/5.jpg";
// end DEFENDER DAY imports
// animationPage imports
import animation1_1 from "./img/animation/1-beauty-lunch.jpg"
import animation1_2 from "./img/animation/1-belov.jpg"
import animation1_3 from "./img/animation/1-dreaming.jpg"
import animation1_4 from "./img/animation/1-frantsen.jpg"
import animation1_5 from "./img/animation/1-safronova.jpg"
import animation2_1 from "./img/animation/2-akvagrim.jpg"
import animation2_2 from "./img/animation/2-bumazhnoe.jpg"
import animation2_3 from "./img/animation/2-diskoteki.jpg"
import animation2_4 from "./img/animation/2-kvesty.jpg"
import animation2_5 from "./img/animation/2-pennaya-vecherinka.jpg"
import animation2_6 from "./img/animation/2-sportivnye.jpg"
import animation2_7 from "./img/animation/2-tantsevalnyse.jpg"
import animation2_8 from "./img/animation/2-tvorcheskie.jpg"
import animation2_9 from "./img/animation/2-vodnye-zabavy.jpg"
import animation3_1 from "./img/animation/3-akvaaerobika.jpg"
import animation3_2 from "./img/animation/3-excursions.jpg"
import animation3_3 from "./img/animation/3-gruppovye.jpg"
import animation3_4 from "./img/animation/3-master-klassy.jpg"
import animation3_5 from "./img/animation/3-nastolnye.jpg"
import animation3_6 from "./img/animation/3-show-programmy.jpg"
import animation3_7 from "./img/animation/3-tantsevalnye.jpg"
import animation3_8 from "./img/animation/3-tematicheskie.jpg"
import animation3_9 from "./img/animation/3-turniry.jpg"
// END animationPage imports
// 8march imports
import march8img1 from "./img/march8Page/заказ-цветов.jpg"
import march8img2 from "./img/march8Page/композиции.jpg"
import march8img3 from "./img/march8Page/акварельное.jpg"
import march8img4 from "./img/march8Page/мастер-класс-по-макияжу.jpg"
import march8img5 from "./img/march8Page/фотозона.jpg"
import march8img6 from "./img/march8Page/фотограф.jpg"
import march8img7 from "./img/march8Page/живая-музыка.jpg"
import march8img8 from "./img/march8Page/велком).jpg"
import march8img9 from "./img/march8Page/комплимент.jpg"
// END 8march imports
//import sliderTheGrilled
import theGrilledSlider1 from "./img/the-grilled/restoran-gril-2.jpg";
import theGrilledSlider2 from "./img/the-grilled/restoran-gril-3.jpg";
import theGrilledSlider3 from "./img/the-grilled/restoran-gril-4.jpg";
//END sliderTheGrilled
// crimeaTour imports
import activnyikrymImg from "./img/crimea-tour/excursions/activnyikrym.jpg"
import dvorcikrymImg from "./img/crimea-tour/excursions/dvorcikrym.jpg"
import gastrokrymImg from "./img/crimea-tour/excursions/gastrokrym.jpg"
import poznavatkrymImg from "./img/crimea-tour/excursions/poznavatkrym.jpg"
import vinnyikrymImg from "./img/crimea-tour/excursions/vinnyikrym.jpg"
// END crimeaTour imports

//import LanguageCamp
import languageCampSlider1 from "./img/language-camp/PhilippaAshcroft.jpg";
import languageCampSlider2 from "./img/language-camp/JackWilliams.jpg";
import languageCampSlider3 from "./img/language-camp/MartinaMagurova.jpg";
import languageCampSlider4 from "./img/language-camp/Degtyar.jpeg";
import excursion1 from "./img/language-camp/caves.jpg";
import excursion2 from "./img/language-camp/castle.jpg";
import excursion3 from "./img/language-camp/castle1.jpg";
import excursion4 from "./img/language-camp/kanatnaya.jpg";
import food1 from "./img/language-camp/shveden.png";
import food2 from "./img/language-camp/tavrika.png";
import food3 from "./img/language-camp/grill.png";
import food4 from "./img/language-camp/mangup.png";
import animations1 from "./img/language-camp/ch1.jpg";
import animations2 from "./img/language-camp/ch2.jpg";
import animations3 from "./img/language-camp/ch3.jpg";
import animations4 from "./img/language-camp/ch4.jpg";
//END sliderLanguageCamp


const commonGridSlides = [
    {
        name: "Курортный отдых",
        firstRow: [
            {
                title: "Семейный отдых",
                img: gridKurortImg1,
                href: '/family-vacation'
            },
            {
                title: "Номера и цены",
                img: gridKurortImg2,
                href: '/nomera-i-tseny'
            },
            {
                title: "Отдых без детей",
                img: gridKurortImg3,
                href: '/vacation-for-yourself'
            },
            {
                title: "Отдых с друзьями",
                img: gridKurortImg4,
                href: '/vacation-with-friends'
            }
        ],
        secondRow: [
            {
                title: "Турпакет",
                img: gridKurortImg5,
            },
            {
                title: "Medical Spa",
                img: gridKurortImg6,
                href: '/medical-spa'
            },
            {
                title: "Командировка",
                img: gridKurortImg7,
            },
            {
                title: "Романтический отдых",
                img: gridKurortImg8,
                href: '/romantic-vacation'
            }],
    },
    {
        name: "События",
        firstRow: [
            {
                title: "Свадьба",
                img: weddingImgGrid,
                href: '/wedding'
            },
            {
                title: "Выездная церемония",
                img: ceremonyImgGrid,
                href: '/visiting-ceremony'
            },
            {
                title: "День рождения",
                img: birthdayImgGrid,
                href: '/birthday'
            }],
        secondRow: [
            {
                title: "Девичник",
                img: henPartyImgGrid,
                href: '/hen-party'
            },
            {
                title: "Мальчишник",
                img: bachelorPartyImgGrid,
                href: '/bachelor-party'
            },
        ],
    },
    {
        name: "Курортный отдых",
        firstRow: [
            {
                title: "Семейный отдых",
                img: gridKurortImg1,
                href: '/family-vacation'
            },
            {
                title: "Номера и цены",
                img: gridKurortImg2,
                href: '/nomera-i-tseny'
            },
            {
                title: "Отдых без детей",
                img: gridKurortImg3,
                href: '/vacation-for-yourself'
            },
            {
                title: "Отдых с друзьями",
                img: gridKurortImg4,
                href: '/vacation-with-friends'
            }
        ],
        secondRow: [
            {
                title: "Турпакет",
                img: gridKurortImg5,
            },
            {
                title: "Medical Spa",
                img: gridKurortImg6,
                href: '/medical-spa'
            },
            {
                title: "Командировка",
                img: gridKurortImg7,
            },
            {
                title: "Романтический отдых",
                img: gridKurortImg8,
                href: '/romantic-vacation'
            }],
    },
    {
        name: "Мероприятия",
        firstRow: [
            {
                title: "Конференции",
                img: conferenceImgGrid,
                href: '/conference'
            },
            {
                title: "Форум",
                img: forumImgGrid,
                href: '/forum'
            },
            {
                title: "Выставка",
                img: exhibitionImgGrid,
                href: '/exhibition'
            },
            {
                title: "Интенсив",
                img: intensiveImgGrid,
                href: '/intensive'
            }
        ],
        secondRow: [
            {
                title: "Семинар/Тренинги",
                img: trainingsImgGrid,
                href: '/trainings'
            },
            {
                title: "Тимбилдинг",
                img: teamImgGrid,
                href: '/team-building'
            },
            {
                title: "Событийный туризм",
                img: tourismImgGrid,
                href: '/event-tourism'
            },
        ],
    },
];
const commonVacationGridSlides = [
    {
        name: "SPA комплекс",
        firstRow: [{title: "Финская сауна", img: gridSpaImg1}, {
            title: "Русская баня",
            img: gridSpaImg2,
        }, {title: "Римская сауна", img: gridSpaImg3}, {
            title: "Хаммам",
            img: gridSpaImg4,
        }],
        secondRow: [{title: `Процедурный кабинет "Расул"`, img: gridSpaImg5}, {
            title: "Соляная пещера",
            img: gridSpaImg6,
        }, {title: "Крытый бассейн", img: gridSpaImg7},
        ],
    },
    {
        name: "Изысканная еда",
        firstRow: [
            {
                title: "Шведский стол",
                img: gridKitchen1,
            },
            {
                title: "Ресторан \"Tavrika\"",
                img: gridKitchen2,
            },
            {
                title: "Лобби-лаундж",
                img: gridKitchen3,
            },
            {
                title: "Pool-бар",
                img: gridKitchen4,
            }
        ],
        secondRow: [{title: "Ресторан \"La Veranda\"", img: gridKitchen5}, {
            title: "Мангал в саду",
            img: gridKitchen6,
        }, {title: "Лобби-бар \"Mangup\"", img: gridKitchen7}],
    },
    {
        name: "AQUA зона",
        firstRow: [
            {
                title: "Пляж (первая береговая линия)",
                img: gridAqua1,
            },
            {
                title: "Бассейн с подогревом",
                img: gridAqua2,
            },
        ],
        secondRow: [
            {
                title: "Бассейн возле моря",
                img: gridAqua3,
            },
            {
                title: "Крытый бассейн",
                img: gridAqua4,
            },
        ],
    },
    {
        name: "AQUA зона",
        firstRow: [
            {
                title: "Пляж (первая береговая линия)",
                img: gridAqua1,
            },
            {
                title: "Бассейн с подогревом",
                img: gridAqua2,
            },
        ],
        secondRow: [
            {
                title: "Бассейн возле моря",
                img: gridAqua3,
            },
            {
                title: "Крытый бассейн",
                img: gridAqua4,
            },
        ],
    },
];
const commonSpecialsSlides = [
    {
        img: ranneeBronirovaniePreviewImg,
        subtitle: "Раннее бронирование",
        title: "Межсезонье",
        link: '/offers/rannee-bronirovanie',
        key: 6,
    },
    {
        img: promoImg4,
        subtitle: "Отдых со скидкой",
        title: "Для крымчан",
        link: '/offers/otdyh-dlya-krymchan',
        key: 0,
    },
    {
        img: promoImg1,
        subtitle: "Летний отдых",
        title: "С выгодой до 20%",
        link: '/offers/letniy-otdyh',
        key: 1,
    },
    {
        img: krymskayaZimaPreviewImg,
        subtitle: "",
        title: "Крымская<br/>зима",
        link: '/offers/krymskaya-zima',
        key: 2,
    },
    {
        img: promoImg3,
        subtitle: "Длительное проживание 2021",
        title: "С выгодой до 25%",
        link: '/offers/dlitelnoe-prozhivaniye',
        key: 4,
    },
    {
        img: promoImg6,
        subtitle: "",
        title: "Онлайн</br>конференции",
        link: '/offers/online-conferences',
        key: 5,
    },
];
const commonClosePoolsSlides = [
    {
        img: closePool1,
        key: 1,
    },
    {
        img: closePool2,
        key: 2,
    },
    {
        img: closePool3,
        key: 3,
    },
    {
        img: closePool4,
        key: 4,
    },
]; //крытые бассейны
const commonExtraServicesSlides = [
    {
        img: extraService1,
        title: "Medical<br/>SPA",
        subtitle: "",
        key: 1,
    },
    {
        img: extraService2,
        title: "Экскурсионные<br>программы",
        subtitle: "",
        key: 2,
    },
    {
        img: extraService3,
        title: "Оформление<br/>залов",
        subtitle: "",
        key: 3,
    },
    {
        img: extraService4,
        title: "Дегустации",
        subtitle: "",
        key: 4,
    },
    {
        img: extraService5,
        title: "Организация<br/>тимбилдинга",
        subtitle: "",
        key: 5,
    },
    {
        img: extraService6,
        title: "Развлекательные<br/>программы",
        subtitle: "",
        key: 5,
    },
    {
        img: extraService7,
        title: "Наличие<br/>трансфера",
        subtitle: "",
        key: 5,
    },
    {
        img: extraService8,
        title: "Фото- и видео-</br>сопровождение",
        subtitle: "",
        key: 6,
    },
]; // доп услуги
const commonAfishaSlides = [
    {
        img: afishaBelov,
        title: "Джаз",
        subtitle: "Белов<br><span style='font-size: 70px'>Ян</span>",
        time: "19:30",
        date: "12 февраля, пятница",
        campus: "Ресторан",
        campusName: "«The Grilled»",
        key: 4,
    },
    {
        img: afishaFilimonova,
        title: "Вокал",
        subtitle: "Филимонова<br><span style='font-size: 50px'>Ирина</span>",
        time: "19:30",
        date: "13 февраля, суббота",
        campus: "Ресторан",
        campusName: "«The Grilled»",
    },
    {
        img: afishaSafronova,
        title: "Вокал",
        subtitle: "Сафронова<br><span style='font-size: 50px'>Татьяна</span>",
        time: "19:30",
        date: "14 февраля, воскресенье",
        campus: "Ресторан",
        campusName: "«The Grilled»",
    },
    {
        img: afishaImg1,
        title: "Тренировки",
        subtitle: "По плаванию<br/>для взрослых",
        time: "и детей",
        date: "",
        campus: "Корпус",
        campusName: "Modern",
        link: '/pool-schedule',
    },
    {
        img: afishaImg2,
        title: "Новое",
        subtitle: "паназиатское<br/><span style='font-size: 78px'>меню</span>",
        time: "",
        date: "",
        campus: "Ресторан",
        campusName: "«The Grilled»",
        link: '/the-grilled',
    },
    {
        img: afishaImg14feb,
        title: "3 дня",
        subtitle: "Незабываемой<br/><span style='font-size: 58px'>романтики</span>",
        time: "",
        date: "",
        campus: "",
        campusName: "12-14 февраля",
        link: '/love-day',
        key: 3,
    },
    {
        img: afishaImg23feb,
        title: "В стиле казино",
        subtitle: "Мужской<br/><span style='font-size: 54px'>праздник</span>",
        time: "",
        date: "",
        campus: "",
        campusName: "23 февраля",
        link: '/23-february',
    },
    {
        img: afishaImg8mar,
        title: "приглашаем на главный",
        subtitle: "женский<br/><span style='font-size: 54px'>праздник</span>",
        time: "",
        date: "",
        campus: "",
        campusName: "8 марта",
        link: '/8-march',
    },
];
const commonClassicCampusSlides = [
    {
        img: classic1img,
        title: "Корпус классик",
        bookingLink: "",
    },
    {
        img: classicStandart1,
        title: "Стандарт",
        link: "/rooms/standart-classic",
        bookingLink: "/booking",
    },
    {
        img: classicImproved1,
        title: "Улучшенный",
        link: "/rooms/improved-classic",
        bookingLink: "/booking",
    },
    {
        img: classicSemiLux2,
        title: "Полулюкс",
        link: "/rooms/semilux-classic",
        bookingLink: "/booking",
    },
    {
        img: classicLux2,
        title: "Люкс",
        link: "/rooms/lux-classic",
        bookingLink: "/booking",
    },
    {
        img: classicPresidentLux1,
        title: "Президентский люкс",
        link: "/rooms/president-lux-classic",
        bookingLink: "/booking",
    },
];
const commonModernCampusSlides = [
    {
        img: modern1img,
        title: "Корпус Модерн",
        bookingLink: "",
    },
    {
        img: modernStandart1,
        title: "Стандарт",
        link: "/rooms/standart-modern",
        bookingLink: "/booking",
    },
    {
        img: modernImproved1,
        title: "Улучшенный",
        link: "/rooms/improved-modern/",
        bookingLink: "/booking",
    },
    {
        img: modernSemilux1,
        title: "Полулюкс",
        link: "/rooms/semilux-modern",
        bookingLink: "/booking",
    },
    {
        img: modernLux1,
        title: "Люкс",
        link: "/rooms/lux-modern",
        bookingLink: "/booking",
    },
    {
        img: modernSpaSuite1,
        title: "SPA-Suite",
        link: "/rooms/vip-suite",
        bookingLink: "/booking",
    },
    {
        img: modernPresident2,
        title: "Президентский люкс",
        link: "/rooms/president-lux-modern",
        bookingLink: "/booking",
    },
];
const commonClassicDescr = [
    '63 номера в классическом стиле',
    'Исторический корпус Классик был полностью реновирован в 2016 году.  Свою историю начал вести в 1913 году и имеет особую атмосферу. Дизайн номеров выполнен в эксклюзивном, классическом стиле.'
];
const commonModernDescr = [
    '146 номеров в современном дизайне',
    'Дизайн интерьера выдержан в стиле Модерн и выполнен в концепции Natural Cool и Ocean Style. Современная эксклюзивная дизайнерская мебель в натуральных тонах создает лучшие условия для комфорта и уюта.'
];
const commonGallerySlides = [
    {
        img: promoImg1,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 1,
    },
    {
        img: promoImg2,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 2,
    },
    {
        img: promoImg3,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 3,
    },
    {
        img: img4,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 4,
    },
    {
        img: img5,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 5,
    },
    {
        img: img6,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 6,
    },
    {
        img: img7,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 7,
    },
    {
        img: img8,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 8,
    },
    {
        img: img9,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 9,
    },
    {
        img: img10,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 10,
    },
    {
        img: img11,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 11,
    },
    {
        img: img12,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 12,
    },
    {
        img: img13,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 13,
    },
    {
        img: img14,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 14,
    },
    {
        img: img15,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 15,
    },
    {
        img: img16,
        title: "Корпус Modern",
        description: "Номер: стандарт улучшенный двухместный",
        href: "#",
        key: 16,
    },
];

// страницы майса
export const micePagesData = {
    centeredSlides: [
        {
            img: forumImg,
            title: 'Кофебрейки',
            subtitle: 'Финальный',
            subsubtitle: 'Фуршет',
            fontsizeSubsubtitle: '69px',
            key: 1,
        },
        {
            img: forumImg1,
            title: 'Настройка',
            subtitle: 'Мультимедиа',
            subsubtitle: 'Оборудования',
            fontsizeSubsubtitle: '49px',
            key: 2,
        },
        {
            img: forumImg2,
            title: 'Подготовка',
            subtitle: 'Оформление',
            subsubtitle: 'Площадки',
            fontsizeSubsubtitle: '69px',
            key: 3,
        },
        {
            img: forumImg3,
            title: 'Полный',
            subtitle: 'Конференц',
            subsubtitle: 'Набор',
            fontsizeSubsubtitle: '69px',
            key: 4,
        },
        {
            img: forumImg4,
            title: 'Трансфер',
            subtitle: 'Участников',
            subsubtitle: 'На место',
            fontsizeSubsubtitle: '69px',
            key: 5,
        },
    ],
    widthSpecialsSliderExhibition: [
        {
            img: parkRoomsSlider,
            title: 'Реликтовый-парк',
            key: 1,
        },
        {
            img: ballroomRoomsSlider,
            title: 'Ballroom',
            key: 2,
        },
        {
            img: lobbyLoungeRoomsSlider,
            title: 'Lobby-Lounge',
            key: 3,
        },
        {
            img: preFunctionRoomsSlider,
            title: 'Pre-Function-зона',
            key: 4,
        },
    ],
    widthSpecialsSliderTeamBuilding: [
        {
            img: aquaZoneRoomsSlider,
            title: 'Аквазона',
            key: 1,
        },
        {
            img: ballroomRoomsSlider,
            title: 'Ballroom',
            key: 2,
        },
        {
            img: confrerenceRoomsImg1RoomsSlider,
            title: 'Конференц-зал 1',
            key: 3,
        },
        {
            img: confrerenceRoomsImg2RoomsSlider,
            title: 'Конференц-зал 2',
            key: 4,
        },
        {
            img: confrerenceRoomsImg3RoomsSlider,
            title: 'Конференц-зал 3',
            key: 5,
        },
        {
            img: confrerenceRoomsImg4RoomsSlider,
            title: 'Конференц-зал 4',
            key: 6,
        },
        {
            img: SPAroomRoomsSlider,
            title: 'The-Shore-SPA',
            key: 7,
        },
        {
            img: tavrikaRoomsSlider,
            title: 'ресторан-Tavrika',
            key: 8,
        },
    ],
    widthSpecialsEventTourism: [
        {
            img: ballroomRoomsSlider,
            title: 'Ball Room',
            key: 1,
        },
        {
            img: confrerenceRoomsImg1RoomsSlider,
            title: 'Конференц-зал 1',
            key: 2,
        },
        {
            img: confrerenceRoomsImg2RoomsSlider,
            title: 'Конференц-зал 2',
            key: 3,
        },
        {
            img: confrerenceRoomsImg3RoomsSlider,
            title: 'Конференц-зал 3',
            key: 4,
        },
        {
            img: confrerenceRoomsImg4RoomsSlider,
            title: 'Конференц-зал 4',
            key: 5,
        },
        {
            img: tavrikaRoomsSlider,
            title: 'ресторан-Tavrika',
            key: 6,
        },
        {
            img: aroundTerRoomsSlider,
            title: 'круглая-терасса',
            key: 7,
        },
    ],
    widthSpecialsSliderForum: [
        {
            img: ballroomRoomsSlider,
            title: 'Ball Room',
            key: 1,
        },
        {
            img: confrerenceRoomsImg1RoomsSlider,
            title: 'Конференц-зал 1',
            key: 2,
        },
        {
            img: confrerenceRoomsImg2RoomsSlider,
            title: 'Конференц-зал 2',
            key: 3,
        },
        {
            img: confrerenceRoomsImg3RoomsSlider,
            title: 'Конференц-зал 3',
            key: 4,
        },
        {
            img: confrerenceRoomsImg4RoomsSlider,
            title: 'Конференц-зал 4',
            key: 5,
        },
        {
            img: preFunctionRoomsSlider,
            title: 'Pre-function зона',
            key: 6,
        },
        {
            img: parkRoomsSlider,
            title: 'реликтовый-парк',
            key: 7,
        },
    ],
    widthSpecialsSliderConference: [
        {
            img: ballroomRoomsSlider,
            title: 'Ball Room',
            key: 1,
        },
        {
            img: confrerenceRoomsImg1RoomsSlider,
            title: 'Конференц-зал 1',
            key: 2,
        },
        {
            img: confrerenceRoomsImg2RoomsSlider,
            title: 'Конференц-зал 2',
            key: 3,
        },
        {
            img: confrerenceRoomsImg3RoomsSlider,
            title: 'Конференц-зал 3',
            key: 4,
        },
        {
            img: confrerenceRoomsImg4RoomsSlider,
            title: 'Конференц-зал 4',
            key: 5,
        },
        {
            img: preFunctionRoomsSlider,
            title: 'Pre-function зона',
            key: 6,
        },
    ],
    widthSpecialsSliderTrainings: [
        {
            img: aquaZoneRoomsSlider,
            title: 'Аквазона',
            key: 1,
        },
        {
            img: aroundTerRoomsSlider,
            title: 'круглая-терасса',
            key: 2,
        },
        {
            img: confrerenceRoomsImg1RoomsSlider,
            title: 'Конференц-зал 1',
            key: 3,
        },
        {
            img: confrerenceRoomsImg2RoomsSlider,
            title: 'Конференц-зал 2',
            key: 4,
        },
        {
            img: confrerenceRoomsImg3RoomsSlider,
            title: 'Конференц-зал 3',
            key: 5,
        },
        {
            img: confrerenceRoomsImg4RoomsSlider,
            title: 'Конференц-зал 4',
            key: 6,
        },
        {
            img: lobbyLoungeRoomsSlider,
            title: 'Lobby-Lounge',
            key: 7,
        },
        {
            img: tavrikaRoomsSlider,
            title: 'ресторан-Tavrika',
            key: 8,
        },
        {
            img: preFunctionRoomsSlider,
            title: 'Pre-Function-зона',
            key: 9,
        },
    ],
    widthSpecialsSliderIntensive: [
        {
            img: ballroomRoomsSlider,
            title: 'Ball Room',
            key: 1,
        },
        {
            img: aquaZoneRoomsSlider,
            title: 'Аквазона',
            key: 2,
        },
        {
            img: beachRoomRoomsSlider,
            title: 'пляж-1-береговая-линия',
            key: 3,
        },
        {
            img: parkRoomsSlider,
            title: 'реликтовый-парк',
            key: 4,
        },
        {
            img: tavrikaRoomsSlider,
            title: 'ресторан-Tavrika',
            key: 5,
        },
    ],
    specialsSlides: commonExtraServicesSlides,
    conferenceIcons: [
        {img: conferenceIcon1},
        {img: conferenceIcon2},
        {img: conferenceIcon3},
        {img: conferenceIcon4},
    ],
    forumIcons: [
        {img: forumIcon1},
        {img: forumIcon2},
        {img: forumIcon3},
        {img: forumIcon4},
        {img: forumIcon5},
    ],
    conferenceIconsAdvantages: [
        {img: conferenceIcon5, text: "Съезд<br>руководителей"},
        {img: conferenceIcon6, text: "Международная<br>премия"},
        {img: conferenceIcon7, text: "Экспертный<br>форум"},
        {img: conferenceIcon8, text: "Конференции<br>для компаний"},
        {img: conferenceIcon9, text: "Показ<br>мод"},
    ],
    conferenceIconsBanner: [
        {img: iconHalls, text: '9 оборудованных залов', key: 1, desc: "9 залов"},
        {img: iconEquipment, text: 'Оборудование для выступлений', key: 2, desc: "Оборудование"},
        {img: iconExcursions, text: 'Экскурсии и тимбилдинги', key: 3, desc: "Экскурсии"},
        {img: iconResidence, text: 'Предложение на проживание в отеле', key: 4, desc: "Проживание"},
    ],
    teamBuildingIconsBanner: [
        {img: iconPrograms, text: 'Разные программы тимбилдинга', key: 1, desc: "Программы тимбилдинга"},
        {img: iconSPA, text: 'SPA-комплекс THE SHORE SPA', key: 2, desc: "SPA"},
        {img: iconExcursions, text: 'Экскурсии и тимбилдинги', key: 3, desc: "Экскурсии"},
        {img: iconResidence, text: 'Предложение на проживание в отеле', key: 4, desc: "Проживание"},
    ],
    exhibitionIconsBanner: [
        {img: iconExhibition, text: 'Выставочные пространства', key: 1, desc: "Пространства"},
        {img: iconEscort, text: 'Организационное сопровождение', key: 2, desc: "Сопровождение"},
        {img: iconBonuses, text: 'Бонусы для организаторов', key: 3, desc: "Бонусы"},
    ]
}

// Домашняя страница
export const homePageData = {
    gridSlides: commonGridSlides,
    centeredSlides: commonAfishaSlides,
    specialsSlides: commonSpecialsSlides,
    gallerySlides: commonGallerySlides,
}

// Старница "Номера и Цены"
export const roomsAndPricesPageData = {
    classicSlides: commonClassicCampusSlides,
    modernSlides: commonModernCampusSlides,
    modernDescr: commonModernDescr,
    classicDescr: commonClassicDescr,
    gridSlides: commonVacationGridSlides,
    centeredSlides: commonAfishaSlides,
}

// Страницы номеров
const modernOtherRoomsSlides = [
    {
        img: otherRoomsModernStandart,
        subtitle: 'номер',
        title: 'Стандарт',
        capacity: "2 человека",
        area: "25",
        link: '/rooms/standart-modern',
        key: 1,
    },
    {
        img: otherRoomsModernImproved,
        subtitle: 'номер',
        title: 'Улучшенный',
        capacity: "2 человека",
        area: "25",
        link: '/rooms/improved-modern/',
        key: 2,
    },
    {
        img: otherRoomsModernSemiLux,
        subtitle: 'номер',
        title: 'Полулюкс',
        capacity: "2 человека",
        area: "50",
        link: '/modern/semilux',
        key: 3,
    },
    {
        img: otherRoomsModernLux,
        subtitle: 'номер',
        title: 'Люкс',
        capacity: "2 человека",
        area: "50",
        link: '/rooms/lux-modern',
        key: 4,
    },
    {
        img: otherRoomsModernSpa,
        subtitle: 'номер',
        title: 'SPA-Suite',
        capacity: "2 человека",
        area: "117",
        link: '/rooms/vip-suite',
        key: 5,
    },
    {
        img: otherRoomsModernDisabled,
        subtitle: 'номер для людей с ограниченными',
        title: 'Возможностями',
        capacity: "2 человека",
        area: "25",
        link: '/rooms/disabled-modern',
        key: 6,
    },
    {
        img: otherRoomsModernPresident,
        subtitle: 'номер',
        title: 'Президентский люкс',
        capacity: "4 человека",
        area: "110",
        link: '/rooms/president-lux-modern',
        key: 6,
    },
];
const classicOtherRoomsSlides = [
    {
        img: otherRoomsClassicStandart,
        subtitle: 'номер',
        title: 'Cтандарт',
        capacity: "2 человека",
        area: "20-25",
        link: '/rooms/standart-classic',
        key: 1,
    },
    {
        img: otherRoomsClassicImproved,
        subtitle: 'номер',
        title: 'Улучшенный',
        capacity: "2 человека",
        area: "20-25",
        link: '/rooms/improved-classic',
        key: 2,
    },
    {
        img: otherRoomsClassicSemilux,
        subtitle: 'номер',
        title: 'Полулюкс',
        capacity: "2 человека",
        area: "20-25",
        link: '/rooms/semilux-classic',
        key: 3,
    },
    {
        img: otherRoomsClassicLux,
        subtitle: 'номер',
        title: 'Люкс',
        capacity: "2 человека",
        area: "45-50",
        link: '/rooms/lux-classic',
        key: 4,
    },
    {
        img: otherRoomsClassicPresident,
        subtitle: 'номер',
        title: 'Президентский люкс',
        capacity: "2 человека",
        area: "130",
        link: '/rooms/president-lux-classic',
        key: 5,
    },
];
const modernTopBlockImg = modern1img;
const classicTopBlockImg = classic1img;

export const roomPageData = {
    modernStandart: {
        bannerImg: modernStandartHero,
        campusName: 'Модерн',
        roomName: 'Стандарт',
        roomNameFontSize: ["14.8vw", "95px"],
        largeGallerySlides: [
            {
                img: modernStandart1,
                key: 1,
            },
            {
                img: modernStandart2,
                key: 2,
            },
            {
                img: modernStandart3,
                key: 3,
            },

        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>с 4 по 10 этаж'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город и горы'},
                {icon: iconSpace, desc: 'Площадь<br/>25 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Однокомнатный номер представлен спальней комнатой с одной двуспальной или двумя раздельными кроватями, гостевой зоной с мягким креслом и журнальным столиком, а также комфортной ванной комнатой.<br/><br/>Все номера данной категории имеют выход на балкон <b>с видом на величественные Крымские горы и город.</b> Для Вашего комфорта балкон оснащен столом и стульями, наслаждайтесь кофе на свежем воздухе c невероятно красивыми видами!'
        },
        centeredSlides: modernOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },
    modernImproved: {
        bannerImg: modernImprovedHero,
        campusName: 'Модерн',
        roomName: 'Улучшенный',
        roomNameFontSize: ["10.6vw", "86px"],
        largeGallerySlides: [
            {
                img: modernImproved1,
                key: 1,
            },
            {
                img: modernImproved2,
                key: 2,
            },
            {
                img: modernImproved3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>с 4 по 10 этаж'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconSea, desc: 'Вид из номера<br/>на море'},
                {icon: iconSpace, desc: 'Площадь<br/>25 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Однокомнатный номер представлен спальней комнатой с одной двуспальной или двумя раздельными кроватями, гостевой зоной с мягким креслом и журнальным столиком, а также комфортной ванной комнатой.<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается <b>великолепный вид на просторы Черного моря.</b> Для Вашего комфорта балкон оснащен столом и стульями, наслаждайтесь кофе на свежем воздухе c невероятно красивыми видами!'
        },
        centeredSlides: modernOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },
    modernSemilux: {
        bannerImg: modernSemiluxHero,
        campusName: 'Модерн',
        roomName: 'Полулюкс',
        roomNameFontSize: ["13.4vw", "86px"],
        largeGallerySlides: [
            {
                img: modernSemilux1,
                key: 1,
            },
            {
                img: modernSemilux2,
                key: 2,
            },
            {
                img: modernSemilux3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>с 4 по 10 этаж'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город и горы'},
                {icon: iconSpace, desc: 'Площадь<br/>50 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Просторный однокомнатный номер представлен спальней комнатой с одной двуспальной кроватью и гостиной с раскладным диваном или софой для уютного отдыха. Номера идеально подходят для семейного отдыха и длительного пребывания в нашем отеле.<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается <b>вид на величественные Крымские горы и город</b>. Для Вашего комфорта балкон и террасы оснащены столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами!'
        },
        centeredSlides: modernOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },
    modernLux: {
        bannerImg: modernLuxHero,
        campusName: 'Модерн',
        roomName: 'Люкс',
        roomNameFontSize: ["21.3vw", "110px"],
        largeGallerySlides: [
            {
                img: modernLux1,
                key: 1,
            },
            {
                img: modernLux2,
                key: 2,
            },
            {
                img: modernLux3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
                'Кофе машина капсульного типа (капсулы включены)'
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>с 4 по 10 этаж'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconSea, desc: 'Вид из номера<br/>на море'},
                {icon: iconSpace, desc: 'Площадь<br/>50 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Просторный двухкомнатный номер либо студия представлены элегантной спальней комнатой с двуспальной кроватью, гостиной с комфортабельным диваном и столовой зоной — идеальное сочетание для ценителей уюта и комфорта. Номера идеально подходят для семейного отдыха и длительного пребывания в нашем отеле.<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается <b>великолепный вид на просторы Черного моря</b>. Для Вашего комфорта балкон и террасы оснащены столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами!'
        },
        centeredSlides: modernOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },
    modernDisabled: {
        bannerImg: modernDisabledHero,
        campusName: 'Модерн',
        roomName: 'Для людей<br/>с ограниченными<br/>возможностями',
        roomNameFontSize: ["7.6vw", "45px"],
        largeGallerySlides: [
            {
                img: modernDisabled1,
                key: 1,
            },
            {
                img: modernDisabled2,
                key: 2,
            },
            {
                img: modernDisabled3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
                'Кофе машина капсульного типа (капсулы включены) '
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 4 и 5 этажах'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город и горы'},
                {icon: iconSpace, desc: 'Площадь<br/>25 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Номера только<br/>connected**'},
            ],
            roomDescription: 'Специально спроектированный однокомнатный номер представлен спальней комнатой с одной двуспальной кроватью, гостевой зоной с мягким креслом и журнальным столиком, а также оснащены всем необходимым: ' +
                '<ul><li>удобной ванной комнатой;</li><li>дополнительными поручнями;</li><li>расширенными дверными проемами;</li><li>соединением в соседний номер для сопровождающих.</li></ul><br/>Для людей с ограниченными возможностями бесплатно предоставляется коляска!<br/><br/>' +
                'Номера имеют выход на балкон с захватывающим видом на живописные Крымские горы и город. Для Вашего комфорта балкон и террасы оснащены столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами. \n'
        },
        centeredSlides: modernOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },
    modernPresidentLux: {
        bannerImg: modernPresidentHero,
        campusName: 'Модерн',
        roomName: 'Президентский<br/>люкс',
        roomNameFontSize: ["8.6vw", "90px"],
        largeGallerySlides: [
            {
                img: modernPresident1,
                key: 1,
            },
            {
                img: modernPresident2,
                key: 2,
            },
            {
                img: modernPresident3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 9 и 10 этажах'},
                {icon: iconCapacity, desc: '4 человека,<br/>2 доп. места*'},
                {icon: iconSea, desc: 'Вид из номера<br/>на море'},
                {icon: iconSpace, desc: 'Площадь<br/>110 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>ванна и душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Изысканный трехкомнатный номер включает в себя две просторные светлые спальни большую гостиную-лаунж с зоной столовой, две ванные комнаты и гостевой санузел, кухню с отдельным входом для персонала. Чтобы отдых стал по-настоящему идеальный номера данной категории продумана каждая деталь, от дизайна интерьера до комплектации, чтобы отдых стал по-настоящему идеальный!<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается великолепный вид на просторы Черного моря. Для Вашего комфорта балкон и террасы оснащены столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами.'
        },
        centeredSlides: modernOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },

    classicStandart: {
        bannerImg: classicStandartHero,
        campusName: 'Классик',
        roomName: 'Стандарт',
        roomNameFontSize: ["14.8vw", "95px"],
        largeGallerySlides: [
            {
                img: classicStandart1,
                key: 1,
            },
            {
                img: classicStandart2,
                key: 2,
            },
            {
                img: classicStandart3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 1 и 2 этажах'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город'},
                {icon: iconSpace, desc: 'Площадь<br/>20-25 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Однокомнатный номер представлен спальней комнатой с одной двуспальной или двумя раздельными кроватями, гостевой зоной с мягким креслом и журнальным столиком, а также комфортной ванной комнатой. Классический дизайн и итальянская мебель создают чувство изящества и комфорта.<br/><br/>Все номера данной категории имеют выход на просторный балкон с видом на парк или Алуштинскую улочку. Для Вашего комфорта балкон оснащен столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами!'
        },
        centeredSlides: classicOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: classicTopBlockImg
    },
    classicImproved: {
        bannerImg: classicImprovedHero,
        campusName: 'Классик',
        roomName: 'Улучшенный',
        roomNameFontSize: ["10.5vw", "95px"],
        largeGallerySlides: [
            {
                img: classicImproved1,
                key: 1,
            },
            {
                img: classicImproved2,
                key: 2,
            },
            {
                img: classicImproved3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 1, 2 и 3 этажах'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город'},
                {icon: iconSpace, desc: 'Площадь<br/>20-25 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Однокомнатный номер представлен спальней комнатой с одной двуспальной или двумя раздельными кроватями, гостевой зоной с мягким креслом и журнальным столиком, а также комфортной ванной комнатой. Классический дизайн и итальянская мебель создают чувство изящества и комфорта.<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается великолепный вид на просторы Черного моря и реликтовый парк. Для Вашего комфорта балкон оснащен столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами!'
        },
        centeredSlides: classicOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: classicTopBlockImg
    },
    classicSemilux: {
        bannerImg: classicSemiLuxHero,
        campusName: 'Классик',
        roomName: 'Полулюкс',
        roomNameFontSize: ["13.4vw", "95px"],
        largeGallerySlides: [
            {
                img: classicSemiLux1,
                key: 1,
            },
            {
                img: classicSemiLux2,
                key: 2,
            },
            {
                img: classicSemiLux3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 1, 2 и 3 этажах'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город'},
                {icon: iconSpace, desc: 'Площадь<br/>20-25 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Просторный двухкомнатный номер либо студия представлены элегантной спальней комнатой с двуспальной кроватью, гостиной с комфортабельным диваном или софой — идеальное сочетание для ценителей уюта и комфорта. Номера идеально подходят для семейного отдыха и длительного пребывания в нашем отеле.<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается великолепный вид на просторы Черного моря и реликтовый парк. Для Вашего комфорта балкон оснащен столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами!'
        },
        centeredSlides: classicOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: classicTopBlockImg
    },
    classicLux: {
        bannerImg: classicLuxHero,
        campusName: 'Классик',
        roomName: 'Люкс',
        roomNameFontSize: ["21.3vw", "110px"],
        largeGallerySlides: [
            {
                img: classicLux1,
                key: 1,
            },
            {
                img: classicLux2,
                key: 2,
            },
            {
                img: classicLux3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 1, 2 и 3 этажах'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconView, desc: 'Вид из номера<br/>на город'},
                {icon: iconSpace, desc: 'Площадь<br/>45-50 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Ванна'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Просторный двухкомнатный номер либо студия представлены элегантной спальней комнатой с двуспальной кроватью, гостиной с комфортабельным диваном и столовой зоной — идеальное сочетание для ценителей уюта и комфорта. Номера идеально подходят для семейного отдыха и длительного пребывания в нашем отеле.<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается великолепный вид на просторы Черного моря и реликтовый парк. Для Вашего комфорта балкон оснащен столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами!'
        },
        centeredSlides: classicOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: classicTopBlockImg
    },
    classicPresidentLux: {
        bannerImg: classicPresidentLuxHero,
        campusName: 'Классик',
        roomName: 'Президентский<br/>Люкс',
        roomNameFontSize: ["8.6vw", "90px"],
        largeGallerySlides: [
            {
                img: classicPresidentLux1,
                key: 1,
            },
            {
                img: classicPresidentLux2,
                key: 2,
            },
            {
                img: classicPresidentLux3,
                key: 3,
            },
            {
                img: img4,
                key: 4,
            },
            {
                img: img5,
                key: 5,
            },
            {
                img: img6,
                key: 6,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
                'Кофе машина капсульного типа (капсулы включены)'
            ],
            features: [
                {icon: iconFloor, desc: 'Номера<br/>на 3 этаже'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconSea, desc: 'Вид из номера<br/>море и парк'},
                {icon: iconSpace, desc: 'Площадь<br/>130 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Ванна'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Изысканный четырехкомнатный номер включает в себя просторную и светлую спальную комнату с двуспальной кроватью, большую гостиную-лаунж с зоной с панорамным окном, соловую зону, гардеробную с отдельным входом для персонала, рабочий кабинет. Чтобы отдых стал по-настоящему идеальный номера данной категории продумана каждая деталь, от дизайна интерьера до комплектации, чтобы отдых стал по-настоящему идеальный!<br/><br/>Все номера данной категории имеют выход на балкон, с которого открывается великолепный вид на просторы Черного мор и реликтовый парк. Для Вашего комфорта балкон и террасы оснащены столом и стульями, наслаждайтесь кофе на свежем воздухе и невероятно красивыми видами.'
        },
        centeredSlides: classicOtherRoomsSlides,
        specialsSlides: commonSpecialsSlides,
        topBlockImg: classicTopBlockImg
    },

    spaSuite: {
        bannerImg: modernSpaSuiteHero,
        campusName: 'Модерн',
        roomName: 'SPA-Suite',
        roomNameFontSize: ["13.4vw", "100px"],
        largeGallerySlides: [
            {
                img: modernSpaSuite1,
                key: 1,
            },
            {
                img: modernSpaSuite2,
                key: 2,
            },
            {
                img: modernSpaSuite3,
                key: 3,
            },
        ],
        descriptionBlockData: {
            includedInPrice: [
                'Завтрак «Шведский стол»',
                'Фитнес-зал',
                'Джакузи в SPA',
                'Детский бассейн',
                'Крытый бассейн с противотоками',
                'Финская сауна',
                'Римская парная',
                'Соляная комната',
                'Уборка в номере',
                'Гладильная (на этаже)',
                'Парковка',
            ],
            roomEquipment: [
                'Wi-Fi, Телефон',
                'Телевизор',
                'Кондиционер',
                'Сейф',
                'Фен, Полотенца, Гардероб',
                'Халат (вафельный) + тапочки',
                'Набор принадлежностей для ванны',
                'Чайник, Чай, кофе, сахар',
                'Стаканы, бокалы, чашки, ложки, штопор',
                'Кофе машина капсульного типа (капсулы включены)'
            ],
            features: [
                {icon: iconFloor, desc: 'Номера расположены<br/>в SPA-комплексе'},
                {icon: iconCapacity, desc: '2 человека,<br/>2 доп. места*'},
                {icon: iconSea, desc: 'Вид на море<br/>и реликтовый парк'},
                {icon: iconSpace, desc: 'Площадь<br/>117 м²'},
                {icon: iconShower, desc: 'Ванная комната:<br/>Душ'},
                {icon: iconConnected, desc: 'Есть номера<br/>connected**'},
            ],
            roomDescription: 'Отдых в номере SPA-Suite — <b>отдых для избранных?</b><br/><br/>Номер SPA-Suite представлен пятью комфортно организованными зонами совершенного отдыха: гостиная, спальная комната, СПА-зона для проведения процедур по уходу за телом, римская парная с зоной отдыха, открытая веранда с джакузи и прекрасным видом на море и реликтовый парк отеля.<br/><br/>Номер расположен в SPA-комплексе отдельно от других номеров, и отличается особой атмосферой изысканного отдыха, комфортной и уединенной обстановки номера и изысканным интерьером.'
        },
        centeredSlides: [...modernOtherRoomsSlides, ...classicOtherRoomsSlides],
        specialsSlides: commonSpecialsSlides,
        topBlockImg: modernTopBlockImg
    },

};

// Страницы "Cемейный отдых", "Отдых для себя", "Отдых с друзьями", "Романтический отдых"
export const vacationPagesData = {
    familyVacationBannerImg,
    familyVacationBannerMobileImg,
    romanticVacationBannerImg,
    romanticVacationBannerMobileImg,
    vacationForYourselfBannerImg,
    vacationForYourselfBannerMobileImg,
    vacationWithFriendsBannerImg,
    vacationWithFriendsBannerMobileImg,
    classicSlides: commonClassicCampusSlides,
    modernSlides: commonModernCampusSlides,
    modernDescr: commonModernDescr,
    classicDescr: commonClassicDescr,
    gridSlides: commonVacationGridSlides,
    centeredSlides: commonAfishaSlides,
    specialsSlides: commonSpecialsSlides,
    gallerySlides: commonGallerySlides,
    wideSlides: [
        {
            img: childrenAnimImg,
            title: "Детская анимация",
            bookingLink: "",
        },
        {
            img: childrenPoolImg,
            title: "Детская зона бассейна",
            bookingLink: "",
        },
        {
            img: birthdayImg,
            title: "День рождения",
            bookingLink: "",
        },
        {
            img: playgroundImg,
            title: "Игровая площадка",
            bookingLink: "",
        },
    ],
};


//The Grilled Data
export const TheGrilledData = {
    theGrilledMainSlides: [
        {
            img: theGrilledSlider1,
            title: "Татаки из говядины",
            key: 1,
        },
        {
            img: theGrilledSlider2,
            title: "Черный ролл с креветками",
            key: 2,
        },
        {
            img: theGrilledSlider3,
            title: "Блэк бургер с курицей",
            key: 3,
        },
    ],
}

//Language camp Data
export const LanguageCampData = {
    languageCampMainSlides: [
        {
            img: languageCampSlider1,
            title: "Philippa Ashcroft",
            key: 1,
        },
        {
            img: languageCampSlider2,
            title: "Jack Williams",
            key: 2,
        },
        {
            img: languageCampSlider3,
            title: "Martina Magurova",
            key: 3,
        },
        {
            img: languageCampSlider4,
            title: "Дегтярь Екатерина Викторовна " +
                "<p>Эксперт ЕГЭ - руководитель кафедры иностранных языков Первой Московской Гимназии</p>",
            key: 4,
        },
    ],
    excursions: [
        {
            img: excursion1,
            subtitle: "Красные",
            title: "пещеры",
            key: 1,
        },
        {
            img: excursion2,
            subtitle: "Ливадийский",
            title: "дворец",
            key: 2,
        },
        {
            img: excursion3,
            subtitle: "Ласточкино",
            title: "гнездо",
            key: 3,
        },
        {
            img: excursion4,
            subtitle: "Канатная",
            title: "дорога",
            key: 4,
        },
    ],
    animations: [
        {
            img: animations1,
            key: 1,
        },
        {
            img: animations2,
            key: 2,
        },
        {
            img: animations3,
            key: 3,
        },
        {
            img: animations4,
            key: 4,
        },
    ],
    food: [
        {
            img: food1,
            subtitle: "Шведский",
            title: "стол",
            key: 1,
        },
        {
            img: food2,
            subtitle: "Ресторан",
            title: "«Tavrika»",
            key: 2,
        },
        {
            img: food3,
            subtitle: "Ресторан",
            title: "«La Veranda»",
            key: 3,
        },
        {
            img: food4,
            subtitle: "Лобби-бар",
            title: "«Mangup»",
            key: 4,
        },
    ],
}

// Страницы ивентов: "Свадьба", "Выездная церемония", "ДР', "Мальчишник", "Девичник"
export const eventPagesData = {
    weddingPages: { // "Свадьба", "Выездная церемония"
        weddingMainSlides: [
            {
                img: weddingSliderImg2,
                title: "Парк",
                descr: 'Площадка с аккуратным мостиком, подсветкой бассейна, с видом на реликтовый парк и морское побережье позволит создать дополнительную атмосферу романтики и уюта.',
                key: 1,
            },
            {
                img: weddingSliderImg1,
                title: "Аквазона",
                descr: 'Площадка с аккуратным мостиком, подсветкой бассейна, с видом на реликтовый парк и морское побережье позволит создать дополнительную атмосферу романтики и уюта.',
                key: 2,
            },
            {
                img: weddingSliderImg3,
                title: "Пляж",
                descr: 'Свадьба на пляже принесет массу положительных эмоций и оставит самые светлые воспоминания. Количество гостей до 60 человек',
                key: 3,
            },
        ],
        weddingIcons: [
            {img: weddingSliderIcon1, text: "Профессиональная<br/>команда<br/>организаторов"},
            {img: weddingSliderIcon2, text: "Изысканное<br/>меню от<br/>бренд-шефа"},
            {img: weddingSliderIcon3, text: "Полное<br/>оснащение<br/>залов"},
            {img: weddingSliderIcon4, text: "В 1 часе езды<br/>на авто<br/>из аэропорта"},
            {img: weddingSliderIcon5, text: "Несколько<br/>вариантов<br/>церемоний"},
        ],
        weddingLargeGallerySlides: [
            {
                video: "https://www.youtube.com/embed/9ZaY4ILBbzA?controls=0",
                key: 1,
            },
            {
                video: "https://www.youtube.com/embed/Ob7a7PzBOAg?controls=0",
                key: 2,
            },
            {
                video: "https://www.youtube.com/embed/fBv_rmcDYKU?controls=0",
                key: 3,
            },
        ], // need videos
        weddingPlacesSlides: [
            {img: placesIcon1, text: 'Обширный<br/>номерной<br/>фонд'},
            {img: placesIcon2, text: 'Профессиональное<br/>звуковое и акустическое<br/>оборудование'},
            {img: placesIcon3, text: 'Персональный<br/>организатор<br/>на площадке'},
            {img: placesIcon4, text: '...и еще 17 пунктов<br/>проверки места для<br/>проведения мероприятия'},
        ],
        weddingGallerySlides: [
            {
                img: weddingGallery1,
                key: 1,
            },
            {
                img: weddingGallery2,
                key: 2,
            },
            {
                img: weddingGallery3,
                key: 3,
            },
            {
                img: weddingGallery4,
                key: 4,
            },
            {
                img: weddingGallery5,
                key: 5,
            },
            {
                img: weddingGallery6,
                title: "Корпус Modern",
                description: "Номер: стандарт улучшенный двухместный",
                href: "#",
                key: 6,
            },
            {
                img: weddingGallery7,
                key: 7,
            },
            {
                img: weddingGallery8,
                key: 8,
            },
            {
                img: weddingGallery9,
                key: 9,
            },
            {
                img: weddingGallery10,
                key: 10,
            },
            {
                img: weddingGallery11,
                key: 11,
            },
            {
                img: weddingGallery12,
                key: 12,
            },
            {
                img: weddingGallery13,
                key: 13,
            },
            {
                img: weddingGallery14,
                key: 14,
            },
            {
                img: weddingGallery15,
                key: 15,
            },
            {
                img: weddingGallery16,
                key: 16,
            },
        ],
        weddingBannerIcons: [
            {img: iconCapacityBanner, descr: 'Вместимость<br/>залов до<br/>300 персон'},
            {img: iconPhotozone, descr: 'Более 100<br/>вариантов<br/>фотозон'},
            {img: iconThematic, descr: 'Тематическое<br/>оформление<br/>свадьбы'},
        ],
        weddingCeremonyBannerIcons: [
            {img: iconCapacityBanner, descr: 'Более<br/>7 площадок<br/>для свадьбы'},
            {img: iconPhotozone, descr: 'Более 100<br/>вариантов<br/>фотозон'},
            {img: iconThematic, descr: 'Тематическое<br/>оформление<br/>свадьбы'},
        ],
    },
    birthdayPage: {
        birthdayBannerIcons: [
            {img: iconCapacityBanner, descr: 'Вместимость<br/>залов до<br/>300 персон'},
            {img: iconPhotozone, descr: 'Более 100<br/>вариантов<br/>фотозон'},
            {img: birthdayIcon6, descr: 'Специальные<br/>условия<br/>на проживание'},
        ],
        birthdayMainSlides: [
            {
                img: birthdayTavrika,
                title: "Ресторан Tavrika",
                descr: 'Подойдет для небольшой дружеской компании.',
                key: 1,
            },
            {
                img: birthdayBallroom,
                title: "Ball Room",
                descr: 'Зал вместит до 120 гостей, его можно украсить в соответствии с общей тональностью мероприятия, подойдет для праздника в любое время года и в любую погоду. Имеет отдельный вход и зону для приветственного фуршета. Есть возможность организации танцпола.',
                key: 2,
            },
            {
                img: birthdayCircleTerrase,
                title: "Круглая терраса",
                descr: 'Зал вместит до 120 гостей, его можно украсить в соответствии с общей тональностью мероприятия, подойдет для праздника в любое время года и в любую погоду. Имеет отдельный вход и зону для приветственного фуршета. Есть возможность организации танцпола.',
                key: 3,
            },
            {
                img: birthdayGreenTerrase,
                title: "Зеленая Терраса",
                descr: 'Зеленая Терраса под открытым небом на втором этаже отеля – идеальное место для летнего праздника в любой компании. Вмещает более 200 чел.',
                key: 4,
            },
            {
                img: birthdayPaluba,
                title: "Верхняя палуба",
                descr: 'Верхняя палуба обладает прекрасным видом на бескрайнее Черное море.',
                key: 5,
            },
            {
                img: birthdayLaVeranda,
                title: "Ресторан La Veranda",
                descr: 'Ресторан в неувядающем классическом стиле с лучшим видом на парк и море: вечернее солнце и все оттенки неба и моря будут служить прекрасным фоном для вашего праздника.',
                key: 6,
            },
        ],
        centeredSlides: [
            {
                img: birthdayCentered3,
                title: 'Организуем',
                subtitle: 'День рождения',
                subsubtitle: 'В vip-suite',
                fontsizeSubsubtitle: '64px',
                key: 1,
            },
            {
                img: birthdayCentered4,
                title: 'Организуем',
                subtitle: 'День рождения',
                subsubtitle: 'С фейерверком',
                fontsizeSubsubtitle: '45px',
                key: 2,
            },
            {
                img: birthdayCentered5,
                title: 'Организуем',
                subtitle: 'День рождения',
                subsubtitle: 'С шоу-програмой',
                fontsizeSubsubtitle: '40px',
                key: 3,
            },
            {
                img: birthdayCentered1,
                title: 'Организуем',
                subtitle: 'Романтичный',
                subsubtitle: 'День рождения',
                fontsizeSubsubtitle: '43px',
                key: 4,
            },
            {
                img: birthdayCentered2,
                title: 'Организуем',
                subtitle: 'Детский',
                subsubtitle: 'День рождения',
                fontsizeSubsubtitle: '43px',
                key: 5,
            },
        ],
        birthdayIcons: [
            {img: birthdayIcon1, text: "Профессиональная<br/>команда<br/>организаторов"},
            {img: birthdayIcon2, text: "Банкетное<br/>меню от<br/>шеф-повара"},
            {img: birthdayIcon3, text: "Уникальный<br/>SPA-комплекс<br/>на 2000 м²"},
            {img: birthdayIcon4, text: "Выгодные<br/>предложения<br/>для именнинников"},
            {img: birthdayIcon5, text: "Живописный<br/>реликтовый<br/>парк"},
        ],
    },
    henPartyPage: {
        henPartyBannerIcons: [
            {img: iconSpa, descr: 'SPA-процедуры,<br/>бассейны<br/>и парные'},
            {img: iconBeach, descr: 'Собственный<br/>закрытый пляж<br/>отеля'},
            {img: birthdayIcon6, descr: 'Специальные<br/>условия<br/>на проживание'},
        ],
        henPartyIcons: [
            {img: iconGirlDrink, text: "Прохладительные<br/>напитки и<br/>легкие закуски"},
            {img: iconClearHand, text: "Расслабляющий<br/>массаж перед<br/>важным днем"},
            {img: iconSpa, text: "Открытые и<br/>закрытые бассейны,<br/>бани и сауны"},
            {img: iconList, text: "Сценарий от<br/>команды<br/>организаторов"},
        ],
    },
    bachelorParty: {
        bachelorPartyBannerIcons: [
            {img: iconSauna, descr: 'Отдых<br/>в бассейне<br/>и парных'},
            {img: iconBeach, descr: 'Собственный<br/>закрытый пляж<br/>отеля'},
            {img: birthdayIcon6, descr: 'Специальные<br/>условия<br/>на проживание'},
        ],
        bachelorPartyIcons: [
            {img: iconDrinks, text: "Настоящие<br/>мужские напитки<br/>и закуски"},
            {img: iconMassage, text: "Тонизирующий<br/>массаж перед<br/>важным днем"},
            {img: birthdayIcon3, text: "Открытые и<br/>закрытые бассейны,<br/>бани и сауны"},
            {img: iconList, text: "Сценарий от<br/>команды<br/>организаторов"},
        ],
    },
    specialsSlides: commonExtraServicesSlides,
    classicSlides: commonClassicCampusSlides,
    modernSlides: commonModernCampusSlides,
    modernDescr: commonModernDescr,
    classicDescr: commonClassicDescr,
};

// Страница "Специальные предложения"
export const promotionsPageData = {
    slides: commonSpecialsSlides,
    pastSlides: [
        {
            img: promoImg7,
            subtitle: "",
            title: "Трансфер<br/>в подарок",
            // link: '#',
            key: 1,
        },
        {
            img: promoImg2,
            subtitle: "План \"Б\"",
            title: "Опережай время",
            // link: '#',
            key: 2,
        },
        {
            img: promoImg8,
            subtitle: "Получи",
            title: "Кешбэк на отдых",
            // link: '#',
            key: 3,
        },
        {
            img: promoImg9,
            subtitle: "Долгожданный отдых",
            title: "С выгодой 10%",
            // link: '#',
            key: 4,
        },
        {
            img: promoImg10,
            subtitle: "",
            title: "Английские<br/>каникулы",
            // link: '#',
            key: 5,
        },
        {
            img: promoImg11,
            subtitle: "",
            title: "Море ждет",
            // link: '#',
            key: 6,
        },

    ],
};


// Страница Трансфера
export const transferPageData = [
    {
        img: transfer1,
        name: 'Легковой автомобиль',
        passengers: 'вместимость до 4 человек',
        price1: '2 800 рублей (70 км)',
        price2: '40 рублей (1 км)',
        price3: '20 рублей (1 км)',
        price4: '750 рублей (1 час)',
        price5: '250 рублей'
    },
    {
        img: transfer2,
        name: 'Минивен',
        passengers: 'вместимость до 6 человек',
        price1: '4 000 рублей (70 км)',
        price2: '60 рублей (1 км)',
        price3: '30 рублей (1 км)',
        price4: '1 000 рублей (1 час)',
        price5: '250 рублей'
    },
    {
        img: transfer2,
        name: 'Минивен',
        passengers: 'вместимость до 8 человек',
        price1: '4 800 рублей (70 км)',
        price2: '70 рублей (1 км)',
        price3: '35 рублей (1 км)',
        price4: '1 300 рублей (1 час)',
        price5: '250 рублей'
    }
];

// Страница Вакансий
export const vacanciesPageData = [
    [
        {
            img: pizzaMakerImg,
            vacancy: 'Пиццамейкер',
            experience: 'от 2 лет',
            salary: 'от 25 тыс.',
            duties: [
                'Работа с тестом, приготовление заготовок',
                'Приготовление пиццы',
                'Соблюдение технологий, стандартов и рецептур приготовления блюд',
                'Контроль и соблюдение чистоты на рабочем месте',
                'Контроль сроков реализации продуктов',
            ],
            demands: [
                'Умение работать с тестом по тех. картам',
                'Опыт в аналогичной должности от 2 лет',
                'Знание ассортимента пиццы и технологии производства',
                'Аккуратный внешний вид, исполнительность, умение работать в команде',
                'Наличие медицинской книжки или готовность её оформить',
            ],
            offer: [
                'Стабильную высокую заработною плату (200 руб. в час или от 35 000 руб. в месяц);',
                'Официальное оформление по законодательству Российской Федерации, полный социальный пакет (оплата больничных листов, предоставление 28 дней ежегодного оплачиваемого отпуска и учебного отпуска, полностью «белая» заработная плата, выплата 2 раза в месяц и др.).',
                'Дружную команду профессионалов',
                'Возможность карьерного роста и передвижения в другие службы отеля',
                'Льготное питание на территории работодателя',
                'Для иногородних сотрудников предоставляем бесплатное проживание'
            ]
        },
    ],
    [
        {
            img: painterImg,
            vacancy: 'МАЛЯР-ШТУКАТУР',
            experience: 'от 1 лет',
            salary: 'от 35 тыс.',
            duties: [
                'Выполнение работ различной сложности, подбор коллера, покраски, оклейки и ремонта разных поверхностей',
                'Подготовка поверхности для выполнения работ, приготовление растворов для различных видов штукатурки',
                'Мелкий ремонт/замена облицовочной плитки, затирка швов',
                'Ремонт/замена  поверхностей из гипсокартона',
            ],
            demands: [
                'Наличие опыта в ремонтно-строительных работах, отделке обязательно',
                'Ответственность, исполнительность, вежливость, аккуратность, пунктуальность, честность, ориентация на результат, умение работать в команде, обучаемость',
            ],
            offer: [
                'Стабильную заработную плату (от 25 000 руб. в месяц);',
                'Официальное оформление по законодательству Российской Федерации, полный социальный пакет (оплата больничных листов, предоставление 28 дней ежегодного оплачиваемого отпуска, полностью «белая» заработная плата, выплата 2 раза в месяц и др.).',
                'Дружную команду профессионалов',
                'Возможность карьерного роста и передвижения в другие службы отеля',
                'Льготное питание на территории работодателя',
                'Для иногородних сотрудников предоставляем бесплатное проживание',
            ]
        }
    ],
];

// Страницы Инфраструктуры
export const infrastructurePagesData = {
    spaPrices: {
        bannerData: {
            subtitleText: "THE SHORE SPA",
            headlineText: ['Услуги', 'И цены'],
            headlineFontSize: ['80px', '80px'],
            headlineMobileFontSize: ['8vw', '10vw'],
            descriptionText: 'На территории отеля Riviera Sunrise Resort&SPA расположен СПА-центр THE SHORE SPA площадью 2000 м². Элегантный и стильный интерьер выполнен известным скандинавским дизайнером Кристианом Люндвалем. Мы приглашаем Вас в атмосферу здоровья, красоты и гармонии.',
            bgImg: SpaPricesBanner,
        },
        spaPricesContent: [
            [
                {
                    name: "Для взрослых",
                    text1: "Разовое посещение Wellness в выходной день",
                    price1: "2000 руб",
                    text2: "СПА-вечер в выходной день (с 16-00 до 21-00)",
                    price2: "1500 руб",
                    text3: "Разовое посещение Wellness в будний день",
                    price3: "1600 руб",
                    text4: "СПА-вечер в будний день (с 16-00 до 21-00)",
                    price4: "1000 руб",
                },
                [
                    {img: adultSPA1, name: 'SPA для взрослых'},
                    {img: adultSPA2, name: 'SPA для взрослых'},
                    {img: adultSPA3, name: 'SPA для взрослых'},
                ]
            ],
            [
                {
                    name: "Для детей",
                    text1: "Разовое посещение Wellness в выходной день",
                    price1: "1000 руб",
                    text2: "СПА-вечер в выходной день (с 16-00 до 21-00)",
                    price2: "750 руб",
                    text3: "Разовое посещение Wellness в будний день",
                    price3: "800 руб",
                    text4: "СПА-вечер в будний день (с 16-00 до 21-00)",
                    price4: "500 руб",
                },
                [
                    {img: childrenSPA1, name: 'SPA для детей'},
                    {img: childrenSPA2, name: 'SPA для детей'},
                    {img: childrenSPA3, name: 'SPA для детей'},
                ]
            ],
            [
                {
                    subscription: true,
                    name: "Абонементы",
                    textTitleAdult: "Абонемент Wellness взрослый",
                    subscriptionAdult1: "4 посещения",
                    subscriptionAdult2: "8 посещения",
                    subscriptionAdult3: "12 посещения",
                    priceAdult1: "6 000 руб",
                    priceAdult2: "10 000 руб",
                    priceAdult3: "14 000 руб",
                    textTitleChildren: "Абонемент Wellness детский",
                    subscriptionChild1: "4 посещения",
                    subscriptionChild2: "8 посещения",
                    subscriptionChild3: "12 посещения",
                    priceChild1: "3 000 руб",
                    priceChild2: "5 000 руб",
                    priceChild3: "7 000 руб",
                },
                [
                    {img: subscriptionSPA1, name: 'SPA абонимент'},
                    {img: subscriptionSPA2, name: 'SPA абонимент'},
                    {img: subscriptionSPA3, name: 'SPA абонимент'},
                ]
            ],
        ]
    },
    restaurants: {
        bannerData: {
            subtitleText: "Инфраструктура",
            headlineText: ['Рестораны', 'И бары', 'Riviera Sunrise'],
            headlineFontSize: ['80px', '80px', '58px'],
            headlineMobileFontSize: ['8vw', '10vw'],
            descriptionText: 'Рестораны и бары отеля Riviera Sunrise Resort & SPA порадуют Вас настоящей гармонией вкуса фирменных блюд от шеф-повара, неповторимыми интерьерами и качеством сервиса. В зависимости от сезона в ресторанах отеля организовано питание в формате «A la Carte» или в формате «шведский стол».',
            bgImg: bannerRestaurants,
        },
        restaurantsContent: [
            [
                {
                    name: "Шведский стол",
                    description: "В ресторане «The Grilled» ежедневно накрывается  завтрак, обед и ужин европейской кухни в формате «Шведский стол». Наслаждайтесь разнообразием меню и большим выбором горячих и холодных блюд, легких закусок, молочных продуктов, горячих",
                    timeBreakfast: "07:30 — 10:30",
                    timeDinner: "13:00 — 15:00",
                    timeSupper: "19:00 — 21:00",
                    kitchen: "европейская",
                    location: "Корпус Модерн, рестораны «The Grilled»"
                },
                [
                    {img: buffet1, name: 'Шведский стол'},
                    {img: buffet2, name: 'Шведский стол'},
                    {img: buffet3, name: 'Шведский стол'},
                    {img: buffet4, name: 'Шведский стол'},
                    {img: buffet5, name: 'Шведский стол'}
                ]
            ],
            [
                {
                    name: "Ресторан «Tavrika»",
                    description: "Ресторан «Tavrika» спешит побаловать своих гостей русско-французской кухней от профессионального шеф-повара Максима Сысоева. Tavrika идеально подходит для закрытого обеда или ужина, а также для проведения праздничного мероприятия. Меню составляется, учитывая все пожелания гостей.",
                    timeBreakfast: "07:30 — 10:30",
                    kitchen: "европейская",
                    location: "Корпус Модерн"
                },
                [
                    {img: tavrika1, name: 'Таврика'},
                    {img: tavrika2, name: 'Таврика'},
                    {img: tavrika3, name: 'Таврика'},
                ]
            ],
            [
                {
                    name: "Ресторан «La Veranda»",
                    description: "Ресторан «La Veranda» расположен на белокаменной веранде исторического корпуса Классик, откуда открывается прекрасный вид на Черное море и парк отеля. В итальянское меню ресторана входят блюда из местных продуктов, старательно отобранных бренд-шефом Андреем Поляшовым.Обширная винная карта, представленная знаменитыми винзаводами: Массандра, Инкерман, Сатера ТМ «Esse», а также европейские и южноамериканские вина.",
                    workingHours: "12:00 — 23:00",
                    kitchen: "локальная кухня",
                    location: "Корпус Classic"
                },
                [
                    {img: laVeranda1, name: 'LaVeranda'},
                    {img: laVeranda2, name: 'LaVeranda'},
                    {img: laVeranda3, name: 'LaVeranda'},
                    {img: laVeranda4, name: 'LaVeranda'}
                ]
            ],
            [
                {
                    name: "Lobby Bar Mangup",
                    description: "Лобби-бар «Mangup» — идеальное место для проведения встреч и непринужденного общения. Комфортно организованное пространство, удобная мебель, внимательное обслуживание и отличный сигнал Wi-Fi – прекрасное место для отдыха. Баре Вам всегда предложат ароматный кофе, элитные сорта виски и Крымские вина.",
                    workingHours: "10:00 — 23:00",
                    menu: "винная карта, барная карта",
                    location: "Корпус Модерн"
                },
                [
                    {img: lobbyMangup1, name: 'Bar Mungup'},
                    {img: lobbyMangup2, name: 'Bar Mungup'},
                    {img: lobbyMangup3, name: 'Bar Mungup'},
                    {img: lobbyMangup4, name: 'Bar Mungup'},
                    {img: lobbyMangup5, name: 'Bar Mungup'}
                ]
            ],
            [
                {
                    name: "Lobby Lounge",
                    description: "Лобби-лаунж — место для спокойного общения.  Здесь Вы всегда сможете продегустировать мягкое крымское шампанское.\n" +
                        "Обширная винная карта, представленная знаменитыми винзаводами: Массандра, Инкерман, Сатера ТМ «Esse», а также европейские и южноамериканские вина.\n",
                    workingHours: "07:00 — 23:00 (с июня по сентябрь)",
                    menu: "винная карта, барная карта",
                    location: "Корпус Classic"
                },
                [
                    {img: lobbyLounge1, name: 'Bar Lounge'},
                    {img: lobbyLounge2, name: 'Bar Lounge'},
                ]
            ],
            [
                {
                    name: "Pool Bar",
                    description: "Бар находится прямо в воде, в одном из открытых бассейнов аква-зоны отеля. В жаркий летний день Вы сможете освежиться прохладными напитками, даже не выходя из бассейна.",
                    workingHours: "9:00- 20:00 (с июня по сентябрь)",
                    menu: "коктейли, винная карта, барная карта",
                },
                [
                    {img: poolBar1, name: 'Pool Bar'},
                    {img: poolBar2, name: 'Pool Bar'},
                    {img: poolBar3, name: 'Pool Bar'},
                    {img: poolBar4, name: 'Pool Bar'}
                ]
            ],
            [
                {
                    name: "Мангал в саду",
                    description: "«Мангал в саду» – это место для ценителей нежного, сочного, ароматного мяса, приготовленного на огне. Особенным шиком и ярким, сочным дополнением станут пряности и соусы, которые мы используем в процессе готовки. Взрыв вкуса обеспечен!",
                    workingHours: "12:00-20:00",
                    kitchen: "фьюжн",
                    location: "реликтовый парк"
                },
                [
                    {img: grillGarden1, name: 'Мангал в саду'},
                    {img: grillGarden2, name: 'Мангал в саду'},
                    {img: grillGarden3, name: 'Мангал в саду'},
                    {img: grillGarden4, name: 'Мангал в саду'},
                    {img: grillGarden5, name: 'Мангал в саду'}
                ]
            ],
        ],
    },
    beachAndPools: {
        bannerData: {
            subtitleText: "Собственный",
            headlineText: ['Пляж', 'И бассейны', 'В Riviera Sunrise'],
            headlineFontSize: ['90px', '69px', '49px'],
            headlineMobileFontSize: ['10vw', '12vw'],
            descriptionText: 'К услугам гостей отеля Ривьера Санрайз, г. Алушта, собственный пляж, два открытых бассейна, детский бассейн и крытый бассейн. Один из открытых бассейнов с подогреваемой пресной водой и Pool-баром. Открытые бассейны работают в теплое время года.',
            bgImg: bannerPools,
        },
        zoomSlides: commonClosePoolsSlides,
    },
    spaPage: {
        bannerData: {
            subtitleText: "Инфраструктура",
            headlineText: ['The Shore', 'SPA'],
            headlineFontSize: ['80px', '100px'],
            headlineMobileFontSize: ['13vw', '17vw'],
            descriptionText: 'На территории отеля Riviera Sunrise Resort&SPA расположен СПА-центр THE SHORE SPA\n' +
                'площадью 2 000 м<sup>2</sup>. Элегантный и стильный интерьер выполнен известным\n' +
                'скандинавским дизайнером Кристианом Люндвалем. Мы приглашаем Вас в атмосферу здоровья, красоты и гармонии.',
            bgImg: spaPageHero,
        },
        slides: [
            {
                img: spaPageAquaImg,
                link: '/infrastructure/aqua-thermal',
                firstLine: ['Аква-<br/>термальная', '50px'],
                secondLine: ['зона', '40px']
            },
            {
                img: spaPageGymImg,
                link: '/infrastructure/gym',
                firstLine: ['Фитнес-', '50px'],
                secondLine: ['зал', '50px']
            },
            {
                img: spaPageSpaServicesImg,
                link: '/infrastructure/spa-services-and-prices',
                firstLine: ['SPA услуги', '50px'],
                secondLine: ['и цены', '40px']
            },
        ]
    },
    gymPage: {
        bannerData: {
            subtitleText: "THE SHORE SPA",
            headlineText: ['Фитнес', 'Зал'],
            headlineFontSize: ['100px', '100px'],
            headlineMobileFontSize: ['17vw', '19vw'],
            descriptionText: 'Мы приглашаем Вас в атмосферу здоровья, красоты и гармонии. Тренажерный зал оснащен современным спортивным оборудованием профессионального класса TechnoGym.',
            bgImg: gymHeroImg,
        },
        mainSlides: [
            {
                img: gymImg1,
                firstLine: ['Кардио', '60px'],
                secondLine: ['Тренажеры', '35px']
            },
            {
                img: gymImg2,
                firstLine: ['Силовые', '55px'],
                secondLine: ['Тренажеры', '35px']
            },
            {
                img: gymImg3,
                firstLine: ['Свободные', '45px'],
                secondLine: ['веса', '50px']
            },
        ],
        apparatusesSlides: [
            {
                img: gymVeloGoriz,
                name: "Велотренажер горизонтальный",
                description: "Идеальный велотренажер для умеренной кардионагрузки и дополнительного комфорта"
            },
            {
                img: gymVelo,
                name: "Велотренажер",
                description: "Наслаждайтесь ощущением езды на дорожном велосипеде. Эргономичная конструкция, выполненная с учетом биомеханики человеческого тела, предлагает разнообразные положения, улучшая вашу производительность."
            },
            {
                img: gymBegovaya,
                name: "Беговая дорожка",
                description: "Профессиональная беговая дорожка, на которой вы можете тренироваться просто и с удовольствием, благодаря новому пользовательскому интерфейсу с QR-кодом для руководства выполнением упражнений и новыми сенсорными датчиками для рук. Дека Long Life Deck, прочная рама и мощный двигатель обеспечивают превосходную производительность."
            },
            {
                img: gymKross,
                name: "Кросс-тренажер",
                description: "Тренажер воспроизводит движения тела во время ходьбы или бега. Естественные движения по эллиптической траектории являются чрезвычайно эффективным кардиоупражнением."
            },
            {
                img: gymVert,
                name: "Вертикальная тяга",
                description: "Благодаря особой конструкции и удобному сиденью ARTIS® Lat Machine идеально подходит для тренировки верхних конечностей и широчайших мышц спины, обеспечивая эффективную и безопасную подготовку в удобном сидячем положении."
            },
            {
                img: gymMnogofunk,
                name: "Многофункциональный тренажер",
                description: "Многофункциональный тренажер, обеспечивающий выполнение многочисленных упражнений для верхних конечностей, в частности, для мышц спины. Тип упражнений зависит от заранее выбранного захвата параллельных перекладин, зафиксированных на каркасе. Нагрузка регулируется посредством платформы с противовесом, на которую становятся ногами, что позволяет уменьшить влияние веса тела в зависимости от типа выбранного упражнения. Значительно облегчает выполнение упражнений на подтягивание на руках и вертикальное отжимание для тех, кто не может их выполнять при подключении всей массы тела. При выполнении вертикальных отжиманий грифы для подтягивания на руках отводятся назад и не ограничивают движение."
            },
            {
                img: gymPress,
                name: "Скамья для пресса",
                description: "Скамья для пресса – многофункциональная скамья для специальной проработки мышц живота, профилактики и корректировка проблем суставов позвоночного столба, улучшение осанки."
            },
            {
                img: gymSmit,
                name: "Тренажер \"Машина Смита\"",
                description: "Основной принцип действия машины Смита – выполнение жима лежа, стоя или сидя, приседания и ряд других упражнений строго в вертикальном положении. Благодаря этому в работу включаются исключительно мышцы, участвующие в упражнении. Зато исключается действие других, таких, как, например, мышц-стабилизаторов."
            },
            {
                img: gymNogi,
                name: "Тренажер для разгибания ног",
                description: "Эффективно и безопасно тренирует четырехглавую мышцу без вовлечения нижнего отдела спины в положении сидя. Тренажер рекомендуется для специальной проработки четырехглавых мышц; для улучшения тонуса мышц и выносливости ног."
            },
            {
                img: gymSpina,
                name: "Лавка для нижней части спины",
                description: "Скамья Lower Back Bench предназначена для тренировки с акцентом на мускулатуру спины, нижний отдел спины, ягодичные мышцы; мышцы задней поверхности бедра; двуглавую мышцу бедра."
            },
        ],
        subscriptionsSlides: [
            {img: gymIcon1, text: '1 посещение<br/>350 рублей'},
            {img: gymIcon2, text: '8 посещений<br/>2 000 рублей'},
            {img: gymIcon3, text: '12 посещений<br/>2 400 рублей'},
            {img: gymIcon4, text: 'Безлимит<br/>3 000 рублей'},
        ],
    },
    aquaThermalPage: {
        bannerData: {
            subtitleText: "THE SHORE SPA",
            headlineText: ['Аква-', 'Термальная', 'Зона'],
            headlineFontSize: ['80px', '80px', '80px'],
            headlineMobileFontSize: ['13.5vw', '11.4vw', '11.4vw'],
            descriptionText: 'На территории отеля Riviera Sunrise Resort&SPA расположен СПА-центр THE SHORE SPA площадью 2000 м².<br/><br/>Элегантный и стильный интерьер выполнен известным скандинавским дизайнером Кристианом Люндвалем. Мы приглашаем Вас в атмосферу здоровья, красоты и гармонии.',
            bgImg: aquaThermalPageHero,
        },
        slides: [
            {
                img: aquaThermalPageFinka,
                subtitle: "",
                title: "Финская сауна",
                text: 'Традиционная горячая и сухая сауна (t 90-110 С, до 20% влажности). Финская сауна благотворно влияет на состояние организма, усиливает обмен веществ, успокаивает нервную систему, восстанавливает бодрость, делает кожу упругой и красивой.',
                // link: '#',
                key: 1,
            },
            {
                img: gridSpaImg2,
                subtitle: "",
                title: "Русская парная",
                text: 'Заполнена влажным, близким к 100% паром, при температуре воздуха 45-60 С. При этом происходит мягкий, не обжигающий кожу, прогрев организма, вызывающий обильное потоотделение. Прогревание улучшает обмен веществ организма, за счет раскрытия пор и удаления ороговевших клеток. Посещение Римской парной способствует укреплению сердечно-сосудистой, дыхательной и эндокринной систем. Кожа становится упругой и эластичной, снимается нервное и мышечное напряжение, восстанавливается бодрость и работоспособность.',
                // link: '/offers/krymskaya-zima',
                key: 2,
            },
            {
                img: aquaThermalRasul,
                subtitle: "",
                title: "Процедурный кабинет",
                text: 'Комфортная температура 45 С и влажность 60-80% — это, прежде всего, отличный пилинг для всего тела, омолаживающий и очищающий кожу благодаря нанесению оздоровительных составов. Благотворно Расул воздействует и на внутренние органы: вещества, содержащиеся в целебных смесях для обертывания, проникают сквозь кожу в глубинные слои, насыщая и подпитывая ткани.',
                // link: '/offers/krymskaya-zima',
                key: 3,
            },
            {
                img: aquaThermalHammam,
                subtitle: "",
                title: "Хаммам",
                text: "Помещение для мягкого прогревания, за счет подогрева стен, лавок и пола (+45 -+50 С, влажность 80-90%), а также отдельное помещение для проведения пенных процедур: отдых на горячем мраморе в облаке невесомой мыльной пены, пилинг и мыльный массаж очистят душу и тело, придадут сил и вернут хорошее настроение.",
                // link: '#',
                key: 4,
            },
            {
                img: aquaThermalPeshchera,
                subtitle: "",
                title: "Соляная пещера",
                text: "Лечебные свойства природных соляных пещер известны давно. Во время сеанса воздух наполняется сухим аэрозолем мелкодисперсной соли. Насыщенный ионами соли воздух проникает в легкие, в результате улучшается дренажная функция бронхов, уменьшается воспаление слизистой дыхательных путей, подавляется жизнедеятельность вредных микроорганизмов. В помещении, оснащенном звуко- и хромотерапией, создается атмосфера, способствующая глубокому расслаблению.",
                // link: '#',
                key: 5,
            },
        ]
    }
}

// Страницы Акций отдельные
export const singlePromotionPages = {
    barhatnyiSezon: {
        bannerImg: krymskayaZimaBannerImg,
        formImg: krymskayaZimaContactBlockImg,
        title: ['Крымская', 'зима'],
        description: 'Отель Riviera Sunrise Resort & SPA предлагает Вам неспеша погрузиться в мир зимней гармонии со скидкой 20% по акции «Крымская зима».',
        hiddenDescription: '<ul>\n' +
            '                                        <li>\n' +
            '                                            Бронирование производится при внесении предоплаты за первые сутки\n' +
            '                                            проживания, в\n' +
            '                                            течение пяти дней;\n' +
            '                                        </li>\n' +
            '                                        <li>\n' +
            '                                            При аннуляции более чем за 14 дня до заезда – бесплатно;\n' +
            '                                        </li>\n' +
            '                                        <li>\n' +
            '                                            При аннуляции менее чем за 14 дня до заезда – взимается стоимость\n' +
            '                                            бронирования\n' +
            '                                            первых суток.\n' +
            '                                        </li>\n' +
            '                                    </ul>',
        firstCol: '<h3><b>Условия акции:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Выгода 20%;</li>\n' +
            '                                    <li>Срок проживания от 7 ночей;</li>\n' +
            '                                    <li>Период проживания С 02.01.2020 по 30.04.2020</li>\n' +
            '                                    <li>Акция распространяется на номера любой категории с любым типом питания;</li>\n' +
            '                                    <li>Детям до 5 лет бесплатное размещение (при условии размещения родителей на основных местах).</li>\n' +
            '                                    <li>Второй и последующие дети в номере размещаются по стоимости соответствующей программы питания для детей от 5 до 12 лет.</li>\n' +
            '                                    <li>Ранний заезд/поздний выезд (при условии наличия свободных номеров);</li>\n' +
            '                                    <li>Акция не суммируется с другими акциями, специальными предложениями и программами лояльности отеля.</li>\n' +
            '                                    <li>Доступно по программе Кэшбэк.</li>\n' +
            '                                </ul>',
        secondCol: '     <h3><b>В стоимость входит:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Парковка;</li>\n' +
            '                                    <li>Размещение в комфортных номерах;</li>\n' +
            '                                    <li>Вкусные и насыщенные завтраки;</li>\n' +
            '                                    <li>Посещение крытого бассейна;</li>\n' +
            '                                    <li>Посещение тренажерного зала;</li>\n' +
            '                                    <li>Посещение зоны отдыха «Теплый сон»;</li>\n' +
            '                                    <li>Прогулки в парке;</li>\n' +
            '                                    <li>Wi-Fi по всей территории отеля;</li>\n' +
            '                                    <li>Посещение SPA-центра: соляной пещеры, финской сауны, римской парной.</li>\n' +
            '                                </ul>',


    },
    letniyOtdyh: {
        bannerImg: letniyOtdyhBannerImg,
        formImg: letniyOtdyhFormBannerImg,
        title: ['Летний отдых 2021', 'с выгодой до 20%'],
        description: 'Специально для Вас особые условия отдыха в отеле Riviera Sunrise Resort & SPA, ALUSHTA.\n' +
            'Отель Riviera Sunrise Resort & SPA предлагает провести незабываемый летний отдых на южном берегу Крыма еще интереснее и выгоднее, чем раньше!',
        hiddenDescription: '<ul>\n' +
            '                                        <li>Бронирование производится при внесении предоплаты 30% от стоимости проживания в течение 5 дней;' +
            '                                        </li>\n' +
            '                                        <li>При аннулировании более чем за 30 дней до заезда – бесплатно;' +
            '                                        </li>\n' +
            '                                        <li>При аннулировании более чем за 14 дней до заезда – взимается полная стоимость первых суток проживания.</li>\n' +
            '                                        <li>При аннулировании менее чем за 14 дней до заезда – взимается половина стоимости предоплаты.</li>\n' +
            '                                    </ul>',
        firstCol: '<h3><b>Условия акции:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Скидка 20%, при бронировании более чем за 4 месяца до заезда;</li>\n' +
            '                                    <li>Скидка 15%, при бронировании более чем за 3 месяца до заезда;</li>\n' +
            '                                    <li>Скидка 10%, при бронировании до более чем за 2 месяца до заезда;</li>\n' +
            '                                    <li>Период проживания с 01.05.2021 до 30.09.2021;</li>\n' +
            '                                    <li>Бронирование производится при внесении предоплаты 30% от стоимости проживания;</li>\n' +
            '                          <li>Ребенок до 5 лет БЕСПЛАТНОЕ размещение (при условии проживания с двумя взрослыми на основных местах).<br/>' +
            '            <li/>Второй и последующие дети в номере размещаются по стоимости соответствующей программы питания для детей от 5 до 12 лет.</li>' +
            '                                    <li>Ранний заезд/поздний выезд (при условии наличия свободных номеров);</li>\n' +
            '                                    <li>Акция не суммируется с другими акциями, специальными предложениями и программами лояльности отеля.</li>\n' +
            '                                </ul>',
        secondCol: '     <h3><b>В стоимость входит:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Парковка;</li>\n' +
            '                                    <li>Размещение в комфортных номерах;</li>\n' +
            '                                    <li>Вкусные и насыщенные завтраки;</li>\n' +
            '                                    <li>Посещение крытого бассейна;</li>\n' +
            '                                    <li>Посещение тренажерного зала;</li>\n' +
            '                                    <li>Посещение зоны отдыха «Теплый сон»;</li>\n' +
            '                                    <li>Прогулки в парке;</li>\n' +
            '                                    <li>Wi-Fi по всей территории отеля;</li>\n' +
            '                                    <li>Посещение SPA-центра: соляной пещеры, финской сауны, римской парной.</li>\n' +
            '                                </ul>',


    },
    dlitelnoeProzh: {
        bannerImg: dlitelnoeBannerImg,
        formImg: dlitelnoeFormBannerImg,
        title: ['Длительное проживание 2021', 'с выгодой до 25%'],
        description: 'Отель Riviera Sunrise Resort & SPA дает отличный повод задержаться в Крыму и дарит своим гостям скидку до 25%!',
        hiddenDescription: '<ul>\n' +
            '                                        <li>Бронирование производится при внесении предоплаты 30% от стоимости проживания в течение 5 дней;' +
            '                                        </li>\n' +
            '                                        <li>При аннулировании более чем за 30 дней до заезда – бесплатно;' +
            '                                        </li>\n' +
            '                                        <li>При аннулировании более чем за 14 дней до заезда – взимается полная стоимость первых суток проживания.</li>\n' +
            '                                        <li>При аннулировании менее чем за 14 дней до заезда – взимается половина стоимости предоплаты.</li>\n' +
            '                                    </ul>',
        firstCol: '<h3><b>Условия акции:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Скидка 25%, при бронировании проживания от 21 ночи;</li>\n' +
            '                                    <li>Скидка 20%, при бронировании проживания от 14 ночей;</li>\n' +
            '                                    <li>Период проживания с 01.05.2021 до 30.09.2021;</li>\n' +
            '                                    <li>Бронирование производится при внесении предоплаты 30% от стоимости проживания;</li>\n' +
            '                                    <li>Ребенок до 5 лет БЕСПЛАТНОЕ размещение (при условии проживания с двумя взрослыми на основных местах).\n' +
            ' Второй и последующие дети в номере размещаются по стоимости соответствующей программы питания для детей от 5 до 12 лет.</li>\n' +
            '                                    <li>Ранний заезд/поздний выезд (при условии наличия свободных номеров);</li>\n' +
            '                                    <li>Акция не суммируется с другими акциями, специальными предложениями и программами лояльности отеля.</li>\n' +
            '                                </ul>',
        secondCol: '     <h3><b>В стоимость входит:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Парковка;</li>\n' +
            '                                    <li>Размещение в комфортных номерах;</li>\n' +
            '                                    <li>Вкусные и насыщенные завтраки;</li>\n' +
            '                                    <li>Посещение крытого бассейна;</li>\n' +
            '                                    <li>Посещение тренажерного зала;</li>\n' +
            '                                    <li>Посещение зоны отдыха «Теплый сон»;</li>\n' +
            '                                    <li>Прогулки в парке;</li>\n' +
            '                                    <li>Wi-Fi по всей территории отеля;</li>\n' +
            '                                    <li>Посещение SPA-центра: соляной пещеры, финской сауны, римской парной.</li>\n' +
            '                                </ul>',


    },
    dlyaKrymchan: {
        bannerImg: dlyaKrymchanBannerImg,
        formImg: dlyaKrymchanFormBannerImg,
        title: ['Отдых', 'Для крымчан -10%'],
        description: 'Отель Riviera Sunrise Resort & SPA приглашает жителей полуострова провести осенние дни у моря в обстановке комфорта и роскоши, со скидкой 10%!',
        hiddenDescription: '<ul>\n' +
            '                                        <li>Бронирование производится при внесении предоплаты за первые сутки проживания, в течение пяти дней;' +
            '                                        </li>\n' +
            '                                        <li>При аннуляции более чем за 3 дня до заезда – бесплатно;;' +
            '                                        </li>\n' +
            '                                        <li>При аннуляции менее чем за 3 дня до заезда – взимается стоимость бронирования первых суток;</li>\n' +
            '                                    </ul>',
        firstCol: '<h3><b>Условия акции:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Период проживания С 10 января по 30 апреля 2021;</li>\n' +
            '                                    <li>Для гостей с крымской пропиской;</li>\n' +
            '                                    <li>Акция распространяется на номера любой категории с любым типом питания;</li>\n' +
            '                                    <li>Ребенок до 5 лет БЕСПЛАТНОЕ размещение (при условии проживания с двумя взрослыми на основных местах).\n' +
            ' Второй и последующие дети в номере размещаются по стоимости соответствующей программы питания для детей от 5 до 12 лет.</li>\n' +
            '                                    <li>Ранний заезд/поздний выезд (при условии наличия свободных номеров);</li>\n' +
            '                                    <li>Акция не суммируется с другими акциями, специальными предложениями и программами лояльности отеля.</li>\n' +
            '                                </ul>',
        secondCol: '     <h3><b>В стоимость входит:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Размещение в комфортных номерах;</li>\n' +
            '                                    <li>Вкусные и насыщенные завтраки;</li>\n' +
            '                                    <li>Посещение крытого бассейна;</li>\n' +
            '                                    <li>Посещение тренажерного зала;</li>\n' +
            '                                    <li>Посещение зоны отдыха «Теплый сон»;</li>\n' +
            '                                    <li>Прогулки в парке;</li>\n' +
            '                                    <li>Wi-Fi по всей территории отеля;</li>\n' +
            '                                    <li>Посещение SPA-центра: соляной пещеры, финской сауны, римской парной.</li>\n' +
            '                                    <li>Парковка;</li>\n' +
            '                                </ul>',


    },
    ranneeBronirovanie: {
        bannerImg: ranneeBronirovanieBannerImg,
        formImg: ranneeBronirovanieFormBannerImg,
        title: ['Раннее бронирование', 'Межсезонье'],
        description: 'Отель Riviera Sunrise Resort & SPA предлагает отличную возможность заблаговременно спланировать отдых по выгодной цене.\n' +
            'Успейте забронировать проживание со скидкой -20% по акции «Раннее бронирование»!',
        hiddenDescription: '<ul>\n' +
            '                                        <li>Бронирование производится при внесении предоплаты стоимостью первых суток;' +
            '                                        </li>\n' +
            '                                        <li>При аннуляции более чем за 14 дня до заезда – бесплатно;' +
            '                                        </li>\n' +
            '                                        <li>При аннуляции менее чем за 14 дня до заезда – взимается полная стоимость предоплаты.</li>\n' +
            '                                    </ul>',
        firstCol: '<h3><b>Условия акции:</b></h3>\n' +
            '<ul>\n' +
            ' \t<li>Скидка 20%;</li>\n' +
            ' \t<li>Период проживания с 10 января  до 30 апреля 2021 года;</li>\n' +
            ' \t<li>Период бронирования за 14 дней до заезда;</li>\n' +
            ' \t<li>Ребенок до 5 лет БЕСПЛАТНОЕ размещение (при условии проживания с двумя взрослыми на основных местах).<br>Второй и последующие дети в номере размещаются по стоимости соответствующей программы питания для детей от 5 до 12 лет.</li>\n' +
            ' \t<li>Ранний заезд/поздний выезд (при условии наличия свободных номеров);</li>\n' +
            ' \t<li>Акция не суммируется с другими акциями, специальными предложениями и программами лояльности отеля.</li> \n' +
            '</ul>',
        secondCol: '     <h3><b>В стоимость входит:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>Размещение в комфортных номерах;</li>\n' +
            '                                    <li>Вкусные и насыщенные завтраки;</li>\n' +
            '                                    <li>Посещение открытого и крытого бассейна;</li>\n' +
            '                                    <li>Посещение тренажерного зала;</li>\n' +
            '                                    <li>Посещение зоны отдыха «Теплый сон»;</li>\n' +
            '                                    <li>Прогулки в парке;</li>\n' +
            '                                    <li>Собственный обустроенный пляж: зонтики, шезлонги, пляжные полотенца;</li>\n' +
            '                                    <li>Wi-Fi по всей территории отеля;</li>\n' +
            '                                    <li>Посещение SPA-центра: соляной пещеры, финской сауны, римской парной.</li>\n' +
            '                                    <li>Парковка;</li>\n' +
            '                                </ul>',


    },
    onlineConferences: {
        bannerImg: onlineConferencesBannerImg,
        formImg: onlineConferencesFormBannerImg,
        title: ['Онлайн конференции', 'В крыму'],
        description: 'Отель Riviera Sunrise Resort & SPA предлагает отличную возможность проведения онлайн-конференций в Крыму.',
        hiddenDescription: '<ul>\n' +
            '                                       100 рублей за участие одного человека<br/>\n' +
            'Минимум 1 000 рублей за один час аренды' +
            '                                    </ul>',
        firstCol: '<h3><b>Что мы предлагаем:</b></h3>\n' +
            '<ul>\n' +
            ' \t<li>Удобное расположение в 40 минутах езды от аэропорта Симферополя</li>\n' +
            ' \t<li>Размещение участников с учетом требований Роскомнадзора, на расстоянии 1,5 метров</li>\n' +
            ' \t<li>Индивидуальный подход к заказчику и качественный сервис</li>\n' +
            ' \t<li>Комфортабельные номера для проживания спикеров, СПА комплекс и рестораны</li>\n' +
            ' \t<li>Большая закрытая территория и развитая инфраструктура</li>\n' +
            ' \t<li>Специальная камера для онлайн трансляций "Logitech BCC950 ConferenceCam"</li> \n' +
            ' \t<li>Wi-Fi по всей территории отеля;</li> \n' +
            '</ul>',
        secondCol: '     <h3><b>В стоимость входит:</b></h3>\n' +
            '                                <ul>\n' +
            '                                    <li>блокнот, ручка, вода</li>\n' +
            '                                    <li>оборудование для онлайн конференций</li>\n' +
            '                                    <li>техническое обеспечение Вашего мероприятия</li>\n' +
            '                                </ul>',


    },

}

// Страница "Medical SPA"
export const medicalSpaPage = {
    bannerImg: medicalSpaBannerImg,
    bannerIcons: [medicalSpaBannerIcon1, medicalSpaBannerIcon2, medicalSpaBannerIcon3, medicalSpaBannerIcon4, medicalSpaBannerIcon5],
    advantagesIcons: [
        {img: medicalSpaAdvIcon1, text: "Наличие<br/>протяженной<br/>набережной"},
        {img: medicalSpaAdvIcon2, text: "Безупречный<br/>сервис<br/>в отеле"},
        {img: medicalSpaAdvIcon3, text: "Команда<br/>профессиональных<br/>аниматоров"},
        {img: medicalSpaAdvIcon4, text: "Пробуждение<br/>внутренних<br/>ресурсов"},
        {img: medicalSpaAdvIcon5, text: "Холистический<br/>подход<br/>к здоровью"},
        {img: medicalSpaAdvIcon6, text: "Наличие<br/>реликтового<br/>парка"},
        {img: medicalSpaAdvIcon7, text: "Персональная<br/>программа<br/>лечения"},
        {img: medicalSpaAdvIcon8, text: "Избавление<br/>от хронического<br/>стресса"},
    ],
    mainSlides: [
        {
            img: medicalSpaPopupImgDihanieZdorovya,
            title: "Дышать - здорово",
            descr: 'Для гостей, желающих получить лечение и оздоровление, программа позволяет применить наиболее эффективные и безопасные виды лечебных процедур',
        },
        {
            img: medicalSpaPopupImgVosstan,
            title: "Восстановление",
            descr: 'Программа рекомендуется широкому кругу людей с усталостью, раздражением, стрессом, низким уровнем иммунитета, концентрации и работоспособности. \n',
        },
        {
            img: medicalSpaPopupImgSpina,
            title: "Здоровая спина",
            descr: 'Программа разработана для людей ведущие сидячий образ жизни, беспокоящих остеохондроз, сколиоз, грыжа межпозвоночных дисков и спондилез.\n',
        },
        {
            img: medicalSpaPopupImgStress,
            title: "Управление стрессом",
            descr: 'Программа показана людям с хроническим стрессом, страдающим вегетососудистой дистонией, неврастенией, депрессией и неврозами.',
        },
        {
            img: medicalSpaPopupImgDetox,
            title: "Детокс",
            descr: 'Программа предназначена для людей с привычкой неправленого питания, страдающие от избыточной тяги к кофе, сладкому, табаку или алкоголю. Также людям, живущим в городах с неблагоприятной экологической обстановкой.\n',
        },
        {
            img: medicalSpaPopupImgDvizhenie,
            title: "Свобода движения",
            descr: 'Программа предназначена людям с недостаточным уровнем активности в повседневной жизни, ведущим сидячий образ жизни, утратившим мышечный тонус\n',
        },
        {
            img: medicalSpaPopupImgSerdce,
            title: "Сильное сердце",
            descr: 'Программа будет полезна людям, страдающим хроническими заболеваниями сердечно сосудистой системы: гипертоническая болезнь, ишемической болезни сердца, заболевания артерий и вен.\n',
        },
    ],
    gallerySlides: commonGallerySlides,
}

// Страница "Партнерам"
export const partnersPageData = {
    partnersIcons: [
        {img: partnerLogo1},
        {img: partnerLogo2},
        {img: partnerLogo3},
        {img: partnerLogo4},
        {img: partnerLogo5},
        {img: partnerLogo6},
        {img: partnerLogo7},
        {img: partnerLogo8},
        {img: partnerLogo9},
        {img: partnerLogo10},
    ],
}

// Страница "Блог"
export const blogPostsData = [
    {
        title: 'Аквазона в отеле Riviera Sunrise',
        description: 'Уединенное расположение бассейна в окружении реликтовых деревьев является одним из достоинств отеля. Прямо в бассейне расположен коктейльный бар. ',
        note: 'О нас',
        link: '#',
        img: birthdayCentered3
    },
    {
        title: 'Аквазона в отеле Riviera Sunrise',
        description: 'Уединенное расположение бассейна в окружении реликтовых деревьев является одним из достоинств отеля. Прямо в бассейне расположен коктейльный бар. ',
        note: 'О нас',
        link: '#',
        img: birthdayCentered4
    },
    {
        title: 'Аквазона в отеле Riviera Sunrise',
        description: 'Уединенное расположение бассейна в окружении реликтовых деревьев является одним из достоинств отеля. Прямо в бассейне расположен коктейльный бар. ',
        note: 'О нас',
        link: '#',
        img: birthdayCentered5
    },
    {
        title: 'Аквазона в отеле Riviera Sunrise',
        description: 'Уединенное расположение бассейна в окружении реликтовых деревьев является одним из достоинств отеля. Прямо в бассейне расположен коктейльный бар. ',
        note: 'О нас',
        link: '#',
        img: birthdayCentered1
    },
    {
        title: 'Аквазона в отеле Riviera Sunrise',
        description: 'Уединенное расположение бассейна в окружении реликтовых деревьев является одним из достоинств отеля. Прямо в бассейне расположен коктейльный бар. ',
        note: 'О нас',
        link: '#',
        img: bachelorPartyImgGrid
    },
    {
        title: 'Аквазона в отеле Riviera Sunrise',
        description: 'Уединенное расположение бассейна в окружении реликтовых деревьев является одним из достоинств отеля. Прямо в бассейне расположен коктейльный бар. ',
        note: 'О нас',
        link: '#',
        img: adultSPA1
    },
]

// Страница "Афиша"
export const afishaPageData = {
    slides: commonAfishaSlides,
    pastSlides: [
        {
            img: afishaImg3,
            title: "Открытый",
            subtitle: "Подогреваемый<br/>бассейн",
            time: "На улице",
            date: "",
            campus: "",
            campusName: "С 26 декабря<br/>по 10 января",
            key: 0,
        },
        {
            img: afishaImg4,
            title: "",
            subtitle: "Новогодний<br><span style='font-size: 70px'>ужин</span>",
            time: "18:00",
            date: "31 декабря",
            campus: "Корпус",
            campusName: "Modern",
            key: 1,
        },
        {
            img: afishaImg5,
            title: "вечер",
            subtitle: "Живой<br><span style='font-size: 70px'>музыки</span>",
            time: "Ольга Легкая",
            date: "",
            campus: "",
            campusName: "18 декабря",
            key: 2,
        },
        {
            img: afishaImg6,
            title: "вечер",
            subtitle: "Незабываемого<br><span style='font-size: 70px'>вокала</span>",
            time: "Алина Авчиян",
            date: "",
            campus: "",
            campusName: "19 декабря",
            key: 3,
        },
        {
            img: animation1_2,
            title: "саксофон",
            subtitle: "Белов<br><span style='font-size: 70px'>Ян</span>",
            time: "19:00",
            date: "21 марта",
            campus: "Ресторан",
            campusName: "«The Grilled»",
        },
        {
            img: animation1_3,
            title: "",
            subtitle: "Dreaming<br><span style='font-size: 50px'>By the sea</span>",
            time: "12:00",
            date: "",
            campus: "АКВАЗОНА",
            campusName: "",
        },
        {
            img: animation1_5,
            title: "Вокал",
            subtitle: "Сафронова<br><span style='font-size: 50px'>Татьяна</span>",
            time: "19:00",
            date: "20 & 27 марта",
            campus: "Ресторан",
            campusName: "«The Grilled»",
        },
        {
            img: animation1_4,
            title: "Гитара и вокал",
            subtitle: "Францен<br><span style='font-size: 50px'>Константин</span>",
            time: "19:00",
            date: "6 марта",
            campus: "Ресторан",
            campusName: "«The Grilled»",
        },
        {
            img: animation1_1,
            title: "",
            subtitle: "Beauty<br><span style='font-size: 60px'>Ланч</span>",
            time: "15:00",
            date: "17 марта",
            campus: "Ресторан",
            campusName: "«The Grilled»",
        },
    ]
}

// Страница 14 февраля
export const loveDayPageData = {
    loveDayMainSlides: [
        {
            img: loveDaySlide1,
            title: "Ресторан для влюбленных:<br/>Цветы, свечи, приглушенный свет, столы для двоих",
            descr: '',
            key: 1,
        },
        {
            img: loveDaySlide2,
            title: "Красочная фотозона",
            descr: '',
            key: 2,
        },
        {
            img: loveDaySlide4,
            title: "Комплимент от отеля в номера высоких категорий",
            descr: '',
            key: 3,
        },
        {
            img: loveDaySlide5,
            title: "Ангельское приветствие:<br/>Дети-ангелочки сделают Вам сюрприз\n",
            descr: '',
            key: 4,
        },
        {
            img: loveDaySlide6,
            title: "Заказ цветов на ресепшн",
            descr: '',
            key: 5,
        },
        {
            img: loveDaySlide7,
            title: "Вечерняя программа",
            descr: '',
            key: 6,
        },
        {
            img: loveDaySlide8,
            title: "Специальное сет-меню в ресторане",
            descr: '',
            key: 7,
        },
    ],
};

// Страница 23 февраля
export const defenderDayPageData = {
    defenderDayMainSlides: [
        {
            img: defenderDaySlide1,
            title: "Рулетка для гостей",
            descr: '',
            key: 1,
        },
        {
            img: defenderDaySlide2,
            title: "Ресторан",
            descr: '',
            key: 2,
        },
        {
            img: defenderDaySlide3,
            title: "Диджей",
            descr: '',
            key: 3,
        },
        {
            img: defenderDaySlide4,
            title: "Шоу-программа с танцевальными номерами",
            descr: '',
            key: 4,
        },
        {
            img: defenderDaySlide5,
            title: "Кенди-бар в стиле казино",
            descr: '',
            key: 5,
        },
    ],
}

// Страница 8 марта
export const march8PageData = {
    march8PageMainSlides: [
        {
            img: march8img1,
            title: "Заказ цветов на месте или заранее",
            descr: '',
            key: 1,
        },
        {
            img: march8img2,
            title: "Мастер класс по составлению цветочной композиции",
            descr: '',
            key: 2,
        },
        {
            img: march8img3,
            title: "Мастер класс по акварельному рисованию",
            descr: '',
            key: 3,
        },
        {
            img: march8img4,
            title: "Мастер класс по макияжу",
            descr: '',
            key: 4,
        },
        {
            img: march8img5,
            title: "Фотозона",
            descr: '',
            key: 5,
        },
        {
            img: march8img6,
            title: "Фотограф",
            descr: '',
            key: 6,
        },
        {
            img: march8img7,
            title: "Живая музыка в ресторане The Grilled",
            descr: '',
            key: 7,
        },
        {
            img: march8img8,
            title: "Welcome подарок",
            descr: '',
            key: 8,
        },
        {
            img: march8img9,
            title: "Комплимент от ресторана",
            descr: '',
            key: 9,
        },
    ],
}

// Страница Турпакет
export const crimeaTourPageData = {
    crimeaTourPageMainSlides: [
        {
            img: activnyikrymImg,
            title: "Активный Крым",
            descr: '1. Сафари-парк «Тайган»<br/>' +
                '2. Долина Привидений на горе Демерджи.<br/>' +
                '3. Крымский государственный заповедник<br/>' +
                '4. Джип тур Мангуп-Кале<br/>' +
                '5. Поляна Сказок и Зоопарк "Сказка"<br/>' +
                '6. Большой Каньон Крыма и Прогулка по Ай-Петри<br/>' +
                '7. Горными тропами Южнобережья.',
            key: 1,
        },
        {
            img: dvorcikrymImg,
            title: "Дворцы Крыма",
            descr: '1. Воронцовский дворец<br/>' +
                '2. Путешествие Бахчисарай. Ханский дворец<br/>' +
                '3. Судакская крепость и бухты Нового Света<br/>' +
                '4. Знаменитая Ливадия<br/>' +
                '5. Великолепная Массандра<br/>' +
                '6. Юсуповский дворец<br/>' +
                '7. Дворец графини Гагариной',
            key: 2,
        },
        {
            img: gastrokrymImg,
            title: "Гастрономический Крым",
            descr: '1. Горная сыроварня<br/>' +
                '2. Устричная ферма<br/>' +
                '3. Караимская кухня.<br/>' +
                '4. Морская прогулка и обед<br/>' +
                '5. Украинское гостеприимство.<br/>' +
                '6. Мастер класс «Обед из местных продуктов»<br/>' +
                '7. Форелевое хозяйство',
            key: 3,
        },
        {
            img: poznavatkrymImg,
            title: "Познавательный Крым",
            descr: '1. Крымская астрофизическая обсерваторию.<br/>' +
                '2. Никитский ботанический сад.<br/>' +
                '3. Пещеры Чатырдага (Мраморная и Эмине-Баир-Хосар)<br/>' +
                '4. Героический Севастополь<br/>' +
                '5. Балаклава. Музей подводных лодок<br/>' +
                '6. Водопад Джур-Джур и Храм-Маяк<br/>' +
                '7. Экскурсия на Крымский солепромысел<br/>',
            key: 4,
        },
        {
            img: vinnyikrymImg,
            title: "Винный Крым",
            descr: '1. Массандровский подвалы<br/>' +
                '2. Шампанерия «Золотая Балка»<br/>' +
                '3. Дегустация "По-царски" в Ливадийском дворце<br/>' +
                '4. Винодельческое хозяйство «ALMA VALLEY»<br/>' +
                '5. Экскурсия в подвалы «Инкермана»<br/>' +
                '6. Виноделья Валерия Захарьина<br/>' +
                '7. Завод шампанских вин «Новый Свет»',
            key: 5,
        },
    ],
}

// Страница Анимация
export const animationPageData = {
    kidsAnimationSlides: [
        {
            img: animation2_8,
            title: "",
            subtitle: "Творческие<br/><span style='font-size: 45px'>мастер-классы</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 1,
            link: ''
        },
        {
            img: animation2_2,
            title: "",
            subtitle: "бумажное<br/><span style='font-size: 70px'>шоу</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 2,
        },
        {
            img: animation2_9,
            title: "",
            subtitle: "Водные<br/><span style='font-size: 60px'>Забавы</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 3,
        },
        {
            img: animation2_4,
            title: "",
            subtitle: "Интерактивные<br/><span style='font-size: 60px'>квесты</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 4,
        },
        {
            img: animation2_7,
            title: "",
            subtitle: "Танцевальные<br/><span style='font-size: 60px'>флэшмобы</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 5,
        },
        {
            img: animation2_5,
            title: "",
            subtitle: "Пенная<br/><span style='font-size: 60px'>вечеринка</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 6,
        },
        {
            img: animation2_3,
            title: "",
            subtitle: "<span style='font-size: 50px'>Дискотеки</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 7,
        },
        {
            img: animation2_6,
            title: "",
            subtitle: "Спортивные<br/><span style='font-size: 45px'>развлечения</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 8,
        },
        {
            img: animation2_1,
            title: "",
            subtitle: "<span style='font-size: 55px'>Аквагрим</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 9,
        },
    ],
    adultAnimationSlides: [
        {
            img: animation3_7,
            title: "",
            subtitle: "Танцевальные<br/><span style='font-size: 45px'>мастер-классы</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 1,
            link: ''
        },
        {
            img: animation3_9,
            title: "",
            subtitle: "Спортивные<br/><span style='font-size: 60px'>турниры</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 2,
        },
        {
            img: animation3_5,
            title: "",
            subtitle: "Настольные<br/><span style='font-size: 70px'>игры</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 3,
        },
        {
            img: animation3_1,
            title: "",
            subtitle: "Аквааэробика<br/><span style='font-size: 60px'>для всех</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 4,
        },
        {
            img: animation3_3,
            title: "",
            subtitle: "Групповые<br/><span style='font-size: 53px'>программы</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 5,
        },
        {
            img: animation3_6,
            title: "",
            subtitle: "Вечерние<br/><span style='font-size: 42px'>шоу-программы</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 6,
        },
        {
            img: animation3_4,
            title: "",
            subtitle: "Творческие<br/><span style='font-size: 53px'>мастерские</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 7,
        },
        {
            img: animation3_2,
            title: "",
            subtitle: "<span style='font-size: 60px'>Экскурсии</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 8,
        },
        {
            img: animation3_8,
            title: "",
            subtitle: "Тематические<br/><span style='font-size: 53px'>мероприятия</span>",
            time: "",
            date: "",
            campus: "Корпус",
            campusName: "Classic",
            key: 9,
        },
    ],

}

export const quizQuestions = [
    {
        question: "Сколько гостей собирается в отель?",
        answers: ['1', '2', '3', 'Более 3х']
    },
    {
        question: "На какое количество ночей вы хотели бы приехать?",
        answers: ['7 ночей', '10 ночей', '14 ночей', 'Другое']
    },
    {
        question: "Какой тип питания вам подходит?",
        answers: ['Только завтраки', 'Завтраки и ужины']
    },
    {
        question: "Какие программы и услуги Вам интересны?",
        answers: ['Экскурсии', 'Услуги няни', 'Гастрономические ужины', 'Medical SPA', 'Трансфер']
    }
]
